import { put, delay, takeEvery, all, call, select } from "redux-saga/effects";
import _ from "lodash";
import moment from "moment-timezone";
import {
  setPageTopLoader,
  setPhotoShootDetailsData,
  setPictreeDataPhotoShootTrend,
  setPictreeDataPhotoDenchuKaisuTrend,
  setPhotoShootMapData,
  setPhotoShootMapDataNtt,
  setPhotoShootMapDataNttFt,
  setPhotoShootMapDataHokuden,
  setPictreeMapSubTypeOption,
  setPictreePhotoShootTrendByAssetNtt,
  setPictreePhotoShootTrendByAssetNttFt,
  setPictreeDataPhotoShootTrendHokuden,
  setPictreeDataPhotoShootTrendNtt,
  setPictreeDataPhotoShootTrendNttFt,
} from "actions";
import { getJwtToken, getDataFromRDS, getDataFromSxi } from "api";
import { PICTREE, ENDPOINT } from "../../constants";
import * as H from "helper";
import seasonConfig from "../../utils/pictree/SeasonDataConfig";
import assetConfig from "../../utils/pictree/AssetConfig";
import chartConfig from "../../utils/ChartConfig";
import { NTT_MAP_BASE_URL } from "../../config/pictreeMapConfig";

export const currentPage = (state) => state.page.currentPage;
export const dateRange = (state) => state.page.dateRangePicTree;
export const dateRangeNtt = (state) => state.page.dateRangePicTreeNtt;
export const dateRangeNttFt = (state) => state.page.dateRangePicTreeNttFt;
export const dateRangeHokuden = (state) => state.page.dateRangePicTreeHokuden;
export const selectedSeason = (state) => state.pictree.selectedSeason;
export const selectedSeasonNtt = (state) => state.pictreeNtt.selectedSeason;
export const selectedSeasonNttFt = (state) => state.pictreeNttFt.selectedSeason;
export const selectedSeasonHokuden = (state) => state.pictreeHokuden.selectedSeason;
export const selectedMapAssetSubType = (state) => state.pictree.mapAssetSubType;

// S3 / CloudFront から JSON を取ってくるヘルパ
function* fetchJson(url) {
  const res = yield call(fetch, url);
  if (!res.ok) {
    const text = yield call([res, res.text]);
    throw new Error(`Fetch failed (${res.status}): ${text}`);
  }
  // Content-Encoding:gzip はブラウザが自動で解凍するので .json() でOK
  return yield call([res, res.json]);
}

function* callSxiWithRetry(query, endpoint, jwtToken, maxRetry = 3, baseDelayMs = 500) {
  for (let i = 0; i < maxRetry; i++) {
    try {
      return yield call(getDataFromSxi, query, endpoint, jwtToken);
    } catch (e) {
      // RDS の "too many connections" 相当などは少し待って再試行
      if (i < maxRetry - 1) {
        const wait = baseDelayMs * Math.pow(2, i) + Math.floor(Math.random() * 150); // exp + jitter
        yield delay(wait);
        continue;
      }
      throw e;
    }
  }
}

const findSeason = (targetDate) => {
  // Convert the targetDate to a moment object for comparison
  const target = moment(targetDate, "YYYY-MM-DD");

  for (let config of seasonConfig.seasonConfig) {
    const startDate = moment(config.dateRange[0], "YYYY-MM-DD");
    const endDate = moment(config.dateRange[1], "YYYY-MM-DD");

    // Check if the target date falls within the date range
    if (target.isBetween(startDate, endDate, null, "[]")) {
      return typeof config.season !== "number"
        ? config.season
        : `Season${config.season}`;
    }
  }
  return null; // If no matching season is found
};

export function* getPictreeDataPhotoShootDetails(action) {
  try {
    yield put(setPageTopLoader(true));
    const jwtToken = yield call(getJwtToken);
    const rangeTarget = yield select(dateRange);
    const propertyQuery = `AND (property = 'tepco' OR property IS NULL)`;

    const sqlQueryCountPhotoDenchu = {
      query: `SELECT * FROM DenchuPhotoShootDenchuEvtProd WHERE CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo') BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59' ${propertyQuery}
      ORDER BY logDate DESC;`,
      database: "KpiDashboard",
      type: "list",
    };

    const [dataPhotoDenchu] = yield all([
      call(
        getDataFromRDS,
        sqlQueryCountPhotoDenchu,
        ENDPOINT.GET_DATA_USERS,
        jwtToken
      ),
    ]);
    const countPhotoDenchu = JSON.parse(dataPhotoDenchu.body);
    let recordArray = [],
      eachData = {};
    _.each(countPhotoDenchu, function (data, index) {
      eachData.user = data[2]["stringValue"];
      eachData.asset_id = data[4]["stringValue"];
      eachData.latitude = parseFloat(data[5]["stringValue"]);
      eachData.longitude = parseFloat(data[6]["stringValue"]);
      eachData.parts = data[7]["stringValue"];
      eachData.picCount = data[8]["longValue"];
      eachData.dateTime = moment(data[14]["longValue"])
        .tz("Asia/Tokyo")
        .format("YYYY/MM/DD hh:mm A");
      recordArray.push(eachData);
      eachData = {};
    });
    yield put(setPhotoShootDetailsData(recordArray));
    yield put(setPageTopLoader(false));
  } catch (err) {
    console.log(err);
  }
}

export function* getPictreeDataPhotoShootTrend(action) {
  try {
    debugger;
    yield put(setPageTopLoader(true));
    const jwtToken = yield call(getJwtToken);
    const rangeTarget = yield select(dateRange);
    const propertyQuery = `AND (property = 'tepco' OR property IS NULL)`;
    const propertyQueryWhere = `WHERE (property = 'tepco' OR property IS NULL)`;
    const selectedSeasonData = yield select(selectedSeason);

    const seasonQuery = (() => {
      if (
        selectedSeasonData.length > 0 &&
        selectedSeasonData[0].seasonId !== undefined
      ) {
        const ids = selectedSeasonData.map((s) => `'${s.seasonId}'`).join(", ");
        // 長さが１なら単一、複数なら IN
        return selectedSeasonData.length === 1
          ? `AND (gameSpaceId IS NULL OR gameSpaceId = ${ids})` // ids は "'id1'"
          : `AND (gameSpaceId IS NULL OR gameSpaceId IN (${ids}))`; // ids は "'id1','id2',…"
      }
      return "";
    })();

    let sqlQueryDenchuPhotoShootTrend = {
      query: `
        SELECT DATE(convert_tz(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')) AS DAY, COUNT(denchuId)
        FROM DenchuPhotoShootDenchuEvtProd
        WHERE CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')
        BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59' ${propertyQuery} ${seasonQuery}
        GROUP BY DATE(convert_tz(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo'))
        ORDER BY logDate ASC;`,
      database: "KpiDashboard",
      type: "list",
    };

    if (action.payload === "hour") {
      sqlQueryDenchuPhotoShootTrend.query = `
        SELECT
          DATE_FORMAT(
              CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo'),
              '%Y-%m-%d %H:00'
          ) AS HOUR,
          COUNT(denchuId) AS denchu_count
        FROM
          DenchuPhotoShootDenchuEvtProd
        WHERE
          CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')
          BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59'
          ${propertyQuery} ${seasonQuery}
        GROUP BY
          HOUR
        ORDER BY
          HOUR ASC;
      `;
    }

    let sqlQueryKankikoPhotoShootTrend = {
      query: `
        SELECT DATE(convert_tz(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')) AS DAY, COUNT(kankikoId)
        FROM DenchuPhotoShootKankikoEvtProd
        WHERE CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')
        BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59' ${propertyQuery} ${seasonQuery}
        GROUP BY DATE(convert_tz(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo'))
        ORDER BY logDate ASC;`,
      database: "KpiDashboard",
      type: "list",
    };

    if (action.payload === "hour") {
      sqlQueryKankikoPhotoShootTrend.query = `
        SELECT
          DATE_FORMAT(
              CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo'),
              '%Y-%m-%d %H:00'
          ) AS HOUR,
          COUNT(kankikoId) AS kankiko_count
        FROM
          DenchuPhotoShootKankikoEvtProd
        WHERE
          CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')
          BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59' ${propertyQuery} ${seasonQuery}
        GROUP BY
          HOUR
        ORDER BY
          HOUR ASC;
      `;
    }

    let sqlQueryGroundEquipPhotoShootTrend = {
      query: `
        SELECT DATE(convert_tz(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')) AS DAY, COUNT(geId)
        FROM DenchuPhotoShootGeEvtProd
        WHERE CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')
        BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59' ${propertyQuery} ${seasonQuery}
        GROUP BY DATE(convert_tz(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo'))
        ORDER BY logDate ASC;`,
      database: "KpiDashboard",
      type: "list",
    };

    if (action.payload === "hour") {
      sqlQueryGroundEquipPhotoShootTrend.query = `
        SELECT
          DATE_FORMAT(
              CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo'),
              '%Y-%m-%d %H:00'
          ) AS HOUR,
          COUNT(geId) AS ground_equip_count
        FROM
          DenchuPhotoShootGeEvtProd
        WHERE
          CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')
          BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59' ${propertyQuery} ${seasonQuery}
        GROUP BY
          HOUR
        ORDER BY
          HOUR ASC;
      `;
    }

    let sqlQueryMhPhotoShootTrend = {
      query: `
        SELECT DATE(convert_tz(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')) AS DAY, COUNT(DISTINCT mhId) AS DAU
        FROM DenchuPhotoShootMhEvtProd
        WHERE CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')
        BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59' ${propertyQuery} ${seasonQuery}
        GROUP BY DATE(convert_tz(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo'))
        ORDER BY logDate ASC;`,
      database: "KpiDashboard",
      type: "list",
    };

    if (action.payload === "hour") {
      sqlQueryMhPhotoShootTrend.query = `
        SELECT
          DATE_FORMAT(
              CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo'),
              '%Y-%m-%d %H:00'
          ) AS HOUR,
          COUNT(DISTINCT mhId) AS denchu_count
        FROM
          DenchuPhotoShootMhEvtProd
        WHERE
            CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')
            BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59' ${propertyQuery} ${seasonQuery}
        GROUP BY
            HOUR
        ORDER BY
            HOUR ASC;
      `;
    }

    let sqlQueryHhPhotoShootTrend = {
      query: `
        SELECT DATE(convert_tz(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')) AS DAY, COUNT(DISTINCT hhId) AS DAU
        FROM DenchuPhotoShootHhEvtProd
        WHERE CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')
        BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59' ${propertyQuery} ${seasonQuery}
        GROUP BY DATE(convert_tz(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo'))
        ORDER BY logDate ASC;`,
      database: "KpiDashboard",
      type: "list",
    };

    if (action.payload === "hour") {
      sqlQueryHhPhotoShootTrend.query = `
        SELECT
          DATE_FORMAT(
              CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo'),
              '%Y-%m-%d %H:00'
          ) AS HOUR,
          COUNT(DISTINCT hhId) AS denchu_count
        FROM
          DenchuPhotoShootHhEvtProd
        WHERE
            CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')
            BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59'
            ${propertyQuery} ${seasonQuery}
        GROUP BY
            HOUR
        ORDER BY
            HOUR ASC;
      `;
    }

    let sqlQueryPhotoShootUniqueTrend = {
      query: `
        SELECT
            DAY,
            COUNT(DISTINCT uid) AS DAU
        FROM (
            SELECT
                DATE(CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')) AS DAY,
                uid
            FROM DenchuPhotoShootDenchuEvtProd
            WHERE CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')
                BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59'
            ${propertyQuery} ${seasonQuery}

            UNION ALL

            SELECT
                DATE(CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')) AS DAY,
                uid
            FROM DenchuPhotoShootKankikoEvtProd
            WHERE CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')
                BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59'
            ${propertyQuery} ${seasonQuery}

            UNION ALL

            SELECT
                DATE(CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')) AS DAY,
                uid
            FROM DenchuPhotoShootMhEvtProd
            WHERE CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')
                BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59'
            ${propertyQuery} ${seasonQuery}

            UNION ALL

            SELECT
                DATE(CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')) AS DAY,
                uid
            FROM DenchuPhotoShootHhEvtProd
            WHERE CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')
                BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59'
            ${propertyQuery} ${seasonQuery}

            UNION ALL

            SELECT
                DATE(CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')) AS DAY,
                uid
            FROM DenchuPhotoShootGeEvtProd
            WHERE CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')
                BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59'
            ${propertyQuery} ${seasonQuery}
        ) AS combined_data
        GROUP BY DAY
        ORDER BY DAY ASC;
      `,
      database: "KpiDashboard",
      type: "list",
    };

    if (action.payload === "hour") {
      sqlQueryPhotoShootUniqueTrend.query = `
        SELECT
              HOUR,
              COUNT(DISTINCT uid) AS uid_count
            FROM (
              SELECT
                  DATE_FORMAT(
                      CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo'),
                      '%Y-%m-%d %H:00'
                  ) AS HOUR,
                  uid
              FROM DenchuPhotoShootDenchuEvtProd
              WHERE
                  CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')
                  BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59'
                  ${propertyQuery} ${seasonQuery}

              UNION ALL

              SELECT
                  DATE_FORMAT(
                      CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo'),
                      '%Y-%m-%d %H:00'
                  ) AS HOUR,
                  uid
              FROM DenchuPhotoShootKankikoEvtProd
              WHERE
                  CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')
                  BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59'
                  ${propertyQuery} ${seasonQuery}

              UNION ALL

              SELECT
                  DATE_FORMAT(
                      CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo'),
                      '%Y-%m-%d %H:00'
                  ) AS HOUR,
                  uid
              FROM DenchuPhotoShootMhEvtProd
              WHERE
                  CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')
                  BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59'
                  ${propertyQuery} ${seasonQuery}

              UNION ALL

              SELECT
                  DATE_FORMAT(
                      CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo'),
                      '%Y-%m-%d %H:00'
                  ) AS HOUR,
                  uid
              FROM DenchuPhotoShootHhEvtProd
              WHERE
                  CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')
                  BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59'
                  ${propertyQuery} ${seasonQuery}

              UNION ALL

              SELECT
                  DATE_FORMAT(
                      CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo'),
                      '%Y-%m-%d %H:00'
                  ) AS HOUR,
                  uid
              FROM DenchuPhotoShootGeEvtProd
              WHERE
                  CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')
                  BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59'
                  ${propertyQuery} ${seasonQuery}
            ) AS combined_data
        GROUP BY HOUR
        ORDER BY HOUR ASC;
      `;
    }

    // here
    let sqlQueryNewUserDailyTrend = {
      query: `
        SELECT
          DATE(CONVERT_TZ(FROM_UNIXTIME(first_logDate/1000), 'UTC', 'Asia/Tokyo')) AS DAY,
          COUNT(*) AS new_unique_users
        FROM (
          SELECT
            uid,
            MIN(logDate) AS first_logDate
          FROM (
            SELECT uid, logDate
            FROM DenchuPhotoShootDenchuEvtProd
            ${propertyQueryWhere}
            ${seasonQuery}

            UNION ALL

            SELECT uid, logDate
            FROM DenchuPhotoShootKankikoEvtProd
            ${propertyQueryWhere}
            ${seasonQuery}

            UNION ALL

            SELECT uid, logDate
            FROM DenchuPhotoShootMhEvtProd
            ${propertyQueryWhere}
            ${seasonQuery}

            UNION ALL

            SELECT uid, logDate
            FROM DenchuPhotoShootHhEvtProd
            ${propertyQueryWhere}
            ${seasonQuery}

            UNION ALL

            SELECT uid, logDate
            FROM DenchuPhotoShootGeEvtProd
            ${propertyQueryWhere}
            ${seasonQuery}

          ) AS all_events
          GROUP BY uid
        ) AS first_events
        WHERE first_logDate
          BETWEEN
            UNIX_TIMESTAMP(CONVERT_TZ('${rangeTarget[0]} 00:00:00', 'Asia/Tokyo','UTC')) * 1000
          AND UNIX_TIMESTAMP(CONVERT_TZ('${rangeTarget[1]} 23:59:59', 'Asia/Tokyo','UTC')) * 1000
        GROUP BY DAY
        ORDER BY DAY ASC;
      `,
      database: "KpiDashboard",
      type: "list",
    };

    if (action.payload === "hour") {
      sqlQueryNewUserDailyTrend.query = `
        SELECT
          DATE_FORMAT(
            CONVERT_TZ(FROM_UNIXTIME(first_logDate/1000), 'UTC', 'Asia/Tokyo'),
            '%Y-%m-%d %H:00'
          ) AS HOUR,
          COUNT(*) AS new_unique_users
        FROM (
          SELECT
            uid,
            MIN(logDate) AS first_logDate
          FROM (
            SELECT uid, logDate
              FROM DenchuPhotoShootDenchuEvtProd
              ${propertyQueryWhere}
              ${seasonQuery}
            UNION ALL

            SELECT uid, logDate
              FROM DenchuPhotoShootKankikoEvtProd
              ${propertyQueryWhere}
              ${seasonQuery}
            UNION ALL

            SELECT uid, logDate
              FROM DenchuPhotoShootMhEvtProd
              ${propertyQueryWhere}
              ${seasonQuery}
            UNION ALL

            SELECT uid, logDate
              FROM DenchuPhotoShootHhEvtProd
              ${propertyQueryWhere}
              ${seasonQuery}
            UNION ALL

            SELECT uid, logDate
              FROM DenchuPhotoShootGeEvtProd
              ${propertyQueryWhere}
              ${seasonQuery}
          ) AS all_events
          GROUP BY uid
        ) AS first_events
        WHERE first_logDate
          BETWEEN
            UNIX_TIMESTAMP(CONVERT_TZ('${rangeTarget[0]} 00:00:00','Asia/Tokyo','UTC')) * 1000
          AND UNIX_TIMESTAMP(CONVERT_TZ('${rangeTarget[1]} 23:59:59','Asia/Tokyo','UTC')) * 1000
        GROUP BY HOUR
        ORDER BY HOUR ASC;
      `;
    }

    const [
      dataTempDenchuPhotoShootTrend,
      dataTempKankikoPhotoShootTrend,
      dataTempGroundEquipPhotoShootTrend,
      dataTempMhPhotoShootTrend,
      dataTempHhPhotoShootTrend,
      dataTempPhotoShootUniqueTrend,
      dataTempPhotoShootNewUserTrend,
    ] = yield all([
      //
      call(
        getDataFromRDS,
        sqlQueryDenchuPhotoShootTrend,
        ENDPOINT.GET_DATA_USERS,
        jwtToken
      ),
      call(
        getDataFromRDS,
        sqlQueryKankikoPhotoShootTrend,
        ENDPOINT.GET_DATA_USERS,
        jwtToken
      ),
      call(
        getDataFromRDS,
        sqlQueryGroundEquipPhotoShootTrend,
        ENDPOINT.GET_DATA_USERS,
        jwtToken
      ),
      call(
        getDataFromRDS,
        sqlQueryMhPhotoShootTrend,
        ENDPOINT.GET_DATA_USERS,
        jwtToken
      ),
      call(
        getDataFromRDS,
        sqlQueryHhPhotoShootTrend,
        ENDPOINT.GET_DATA_USERS,
        jwtToken
      ),
      call(
        getDataFromRDS,
        sqlQueryPhotoShootUniqueTrend,
        ENDPOINT.GET_DATA_USERS,
        jwtToken
      ),
      call(
        getDataFromRDS,
        sqlQueryNewUserDailyTrend,
        ENDPOINT.GET_DATA_USERS,
        jwtToken
      ),
    ]);
    const dataDenchuPhotoShootTrend = JSON.parse(
      dataTempDenchuPhotoShootTrend.body
    );
    const dataKankikoPhotoShootTrend = JSON.parse(
      dataTempKankikoPhotoShootTrend.body
    );
    const dataGroundEquipPhotoShootTrend = JSON.parse(
      dataTempGroundEquipPhotoShootTrend.body
    );
    const dataMhPhotoShootTrend = JSON.parse(dataTempMhPhotoShootTrend.body);
    const dataHhPhotoShootTrend = JSON.parse(dataTempHhPhotoShootTrend.body);
    const dataPhotoShootUniqueTrend = JSON.parse(
      dataTempPhotoShootUniqueTrend.body
    );
    const dataPhotoShootNewUserTrend = JSON.parse(
      dataTempPhotoShootNewUserTrend.body
    );

    // Set xAxisDate
    let xAxisDate = [],
      dataDenchuArray = [],
      dataKankikoArray = [],
      dataGroundEquipArray = [],
      dataMhArray = [],
      dataHhArray = [],
      dataUniqueArray = [],
      dataNewUserArray = [],
      recordArray = [];
    const daysArray =
      action.payload === "day"
        ? H.FormatDateHelper.getDaysListBetweenDays(
            rangeTarget[0],
            rangeTarget[1]
          )
        : H.FormatDateHelper.getHoursListBetweenDays(
            rangeTarget[0],
            rangeTarget[1]
          );
    _.each(daysArray, function (data) {
      xAxisDate.push(data);
    });

    const allZero = (arr) => arr.every((v) => v === 0);

    xAxisDate.forEach((date) => {
      const data = _.find(
        dataDenchuPhotoShootTrend,
        (item) => _.get(item, "[0].stringValue") === date
      );
      if (data) {
        dataDenchuArray.push(_.get(data, "[1].longValue"));
      } else {
        dataDenchuArray.push(0);
      }

      // Kankiko data
      const kankikoData = _.find(
        dataKankikoPhotoShootTrend,
        (item) => _.get(item, "[0].stringValue") === date
      );
      if (kankikoData) {
        dataKankikoArray.push(_.get(kankikoData, "[1].longValue"));
      } else {
        dataKankikoArray.push(0);
      }

      // Ground Equip data
      const groundEquipData = _.find(
        dataGroundEquipPhotoShootTrend,
        (item) => _.get(item, "[0].stringValue") === date
      );
      if (groundEquipData) {
        dataGroundEquipArray.push(_.get(groundEquipData, "[1].longValue"));
      } else {
        dataGroundEquipArray.push(0);
      }

      // MH data
      const mhData = _.find(
        dataMhPhotoShootTrend,
        (item) => _.get(item, "[0].stringValue") === date
      );
      if (mhData) {
        dataMhArray.push(_.get(mhData, "[1].longValue"));
      } else {
        dataMhArray.push(0);
      }

      // HH data
      const hhData = _.find(
        dataHhPhotoShootTrend,
        (item) => _.get(item, "[0].stringValue") === date
      );
      if (hhData) {
        dataHhArray.push(_.get(hhData, "[1].longValue"));
      } else {
        dataHhArray.push(0);
      }

      // Unique data
      const uniqueData = _.find(
        dataPhotoShootUniqueTrend,
        (item) => _.get(item, "[0].stringValue") === date
      );
      if (uniqueData) {
        dataUniqueArray.push(_.get(uniqueData, "[1].longValue"));
      } else {
        dataUniqueArray.push(0);
      }

      // New User data
      const newUserData = _.find(
        dataPhotoShootNewUserTrend,
        (item) => _.get(item, "[0].stringValue") === date
      );
      if (newUserData) {
        dataNewUserArray.push(_.get(newUserData, "[1].longValue"));
      } else {
        dataNewUserArray.push(0);
      }
    });

    const countDenchu = allZero(dataDenchuArray) ? false : dataDenchuArray;
    const countKankiko = allZero(dataKankikoArray) ? false : dataKankikoArray;
    const countGroundEquip = allZero(dataGroundEquipArray)
      ? false
      : dataGroundEquipArray;
    const countMh = allZero(dataMhArray) ? false : dataMhArray;
    const countHh = allZero(dataHhArray) ? false : dataHhArray;

    const photoshootCountData = {
      date: xAxisDate,
      countDenchu,
      countKankiko,
      countGroundEquip,
      countMh,
      countHh,
      unique: dataUniqueArray,
      newUser: dataNewUserArray,
    };
    recordArray.push(photoshootCountData);

    yield put(setPictreeDataPhotoShootTrend(recordArray));
    yield put(setPageTopLoader(false));
  } catch (err) {
    console.log(err);
  }
}

export function* getPictreeDataPhotoShootTrendNttFt(action) {
  try {
    yield put(setPageTopLoader(true));
    const jwtToken = yield call(getJwtToken);
    const rangeTarget = yield select(dateRangeNttFt);
    const seasonSelectedNttFt = yield select(selectedSeasonNttFt);
    const propertyQuery = `AND property = 'nttft'`;
    const seasonQuery = (() => {
      if (
        seasonSelectedNttFt.length > 0 &&
        seasonSelectedNttFt[0].seasonId !== undefined
      ) {
        const ids = seasonSelectedNttFt
          .map((s) => `'${s.seasonId}'`)
          .join(", ");
        return seasonSelectedNttFt.length === 1
          ? `AND gameSpaceId = ${ids}`         // ids は "'id1'"
          : `AND (gameSpaceId IN (${ids}))`;     // ids は "'id1','id2',…"
      }
      return "";
    })();
    let sqlQueryDenchuPhotoShootTrend = {
      query: `
        SELECT DATE(convert_tz(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')) AS DAY, COUNT(denchuId)
        FROM DenchuPhotoShootDenchuEvtProd
        WHERE CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')
        BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59' ${propertyQuery} ${seasonQuery}
        GROUP BY DATE(convert_tz(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo'))
        ORDER BY logDate ASC;`,
      database: "KpiDashboard",
      type: "list",
    };

    if (action.payload === "hour") {
      sqlQueryDenchuPhotoShootTrend.query = `
        SELECT
          DATE_FORMAT(
              CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo'),
              '%Y-%m-%d %H:00'
          ) AS HOUR,
          COUNT(denchuId) AS denchu_count
        FROM
          DenchuPhotoShootDenchuEvtProd
        WHERE
          CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')
          BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59'
          ${propertyQuery} ${seasonQuery}
        GROUP BY
          HOUR
        ORDER BY
          HOUR ASC;
      `;
    }

    let sqlQueryPhotoShootUniqueTrend = {
      query: `
        SELECT DATE(convert_tz(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')) AS DAY, COUNT(DISTINCT uid) AS DAU
        FROM DenchuPhotoShootDenchuEvtProd
        WHERE CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')
        BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59'
        ${propertyQuery} ${seasonQuery}
        GROUP BY DATE(convert_tz(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo'))
        ORDER BY logDate ASC;`,
      database: "KpiDashboard",
      type: "list",
    };

    if (action.payload === "hour") {
      sqlQueryPhotoShootUniqueTrend.query = `
        SELECT
          DATE_FORMAT(
              CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo'),
              '%Y-%m-%d %H:00'
          ) AS HOUR,
          COUNT(DISTINCT uid) AS uid_count
        FROM
        DenchuPhotoShootDenchuEvtProd
        WHERE
            CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')
            BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59'
            ${propertyQuery} ${seasonQuery}
        GROUP BY
            HOUR
        ORDER BY
            HOUR ASC;
      `;
    }

    let sqlQueryNewUserDailyTrend = {
      query: `
        SELECT
          DATE(CONVERT_TZ(FROM_UNIXTIME(first_logDate/1000), 'UTC', 'Asia/Tokyo')) AS DAY,
          COUNT(*) AS new_unique_users
        FROM (
          SELECT
            uid,
            MIN(logDate) AS first_logDate,
            SUBSTRING_INDEX(
              GROUP_CONCAT(property ORDER BY logDate ASC),
              ',', 1
            ) AS first_property
          FROM DenchuPhotoShootDenchuEvtProd
          WHERE gameSpaceId = '${seasonSelectedNttFt[0].seasonId}'
          GROUP BY uid
        ) AS first_events
        WHERE
          first_property IN ('nttft')
          AND first_logDate BETWEEN
            UNIX_TIMESTAMP(CONVERT_TZ('${rangeTarget[0]} 00:00:00', 'Asia/Tokyo','UTC')) * 1000
            AND UNIX_TIMESTAMP(CONVERT_TZ('${rangeTarget[1]} 23:59:59', 'Asia/Tokyo','UTC')) * 1000
        GROUP BY DAY
        ORDER BY DAY ASC;
      `,
      database: "KpiDashboard",
      type: "list",
    };

    if (action.payload === "hour") {
      sqlQueryNewUserDailyTrend.query = `
        SELECT
          DATE_FORMAT(
            CONVERT_TZ(FROM_UNIXTIME(first_logDate/1000), 'UTC', 'Asia/Tokyo'),
            '%Y-%m-%d %H:00'
          ) AS HOUR,
          COUNT(*) AS new_unique_users
        FROM (
          SELECT
            uid,
            MIN(logDate) AS first_logDate,
            SUBSTRING_INDEX(
              GROUP_CONCAT(property ORDER BY logDate ASC),
              ',', 1
            ) AS first_property
          FROM DenchuPhotoShootDenchuEvtProd
          WHERE gameSpaceId = '${seasonSelectedNttFt[0].seasonId}'
          GROUP BY uid
        ) AS first_events
        WHERE
          first_property IN ('nttft')
          AND first_logDate BETWEEN
            UNIX_TIMESTAMP(CONVERT_TZ('${rangeTarget[0]} 00:00:00', 'Asia/Tokyo','UTC')) * 1000
            AND UNIX_TIMESTAMP(CONVERT_TZ('${rangeTarget[1]} 23:59:59', 'Asia/Tokyo','UTC')) * 1000
        GROUP BY HOUR
        ORDER BY HOUR ASC;
      `;
    }

    const [
      dataTempDenchuPhotoShootTrend,
      dataTempPhotoShootUniqueTrend,
      dataTempPhotoShootNewUserTrend,
    ] = yield all([
      call(
        getDataFromRDS,
        sqlQueryDenchuPhotoShootTrend,
        ENDPOINT.GET_DATA_USERS,
        jwtToken
      ),
      call(
        getDataFromRDS,
        sqlQueryPhotoShootUniqueTrend,
        ENDPOINT.GET_DATA_USERS,
        jwtToken
      ),
      call(
        getDataFromRDS,
        sqlQueryNewUserDailyTrend,
        ENDPOINT.GET_DATA_USERS,
        jwtToken
      ),
    ]);
    const dataDenchuPhotoShootTrend = JSON.parse(
      dataTempDenchuPhotoShootTrend.body
    );
    const dataPhotoShootUniqueTrend = JSON.parse(
      dataTempPhotoShootUniqueTrend.body
    );
    const dataPhotoShootNewUserTrend = JSON.parse(
      dataTempPhotoShootNewUserTrend.body
    );

    // Set xAxisDate
    let xAxisDate = [],
      dataDenchuArray = [],
      dataUniqueArray = [],
      dataNewUserArray = [],
      recordArray = [];
    const daysArray =
      action.payload === "day"
        ? H.FormatDateHelper.getDaysListBetweenDays(
            rangeTarget[0],
            rangeTarget[1]
          )
        : H.FormatDateHelper.getHoursListBetweenDays(
            rangeTarget[0],
            rangeTarget[1]
          );
    _.each(daysArray, function (data) {
      xAxisDate.push(data);
    });

    xAxisDate.forEach((date) => {
      const data = _.find(
        dataDenchuPhotoShootTrend,
        (item) => _.get(item, "[0].stringValue") === date
      );
      if (data) {
        dataDenchuArray.push(_.get(data, "[1].longValue"));
      } else {
        dataDenchuArray.push(0);
      }

      // Unique data
      const uniqueData = _.find(
        dataPhotoShootUniqueTrend,
        (item) => _.get(item, "[0].stringValue") === date
      );
      if (uniqueData) {
        dataUniqueArray.push(_.get(uniqueData, "[1].longValue"));
      } else {
        dataUniqueArray.push(0);
      }

      // New User data
      const newUserData = _.find(
        dataPhotoShootNewUserTrend,
        (item) => _.get(item, "[0].stringValue") === date
      );
      if (newUserData) {
        dataNewUserArray.push(_.get(newUserData, "[1].longValue"));
      } else {
        dataNewUserArray.push(0);
      }
    });

    const photoshootCountData = {
      date: xAxisDate,
      countDenchu: dataDenchuArray,
      unique: dataUniqueArray,
      newUser: dataNewUserArray,
    };
    recordArray.push(photoshootCountData);

    yield put(setPictreeDataPhotoShootTrendNttFt(recordArray));
    yield put(setPageTopLoader(false));
  } catch (err) {
    console.log(err);
  }
}

export function* getPictreeDataPhotoShootTrendNtt(action) {
  try {
    yield put(setPageTopLoader(true));
    const jwtToken = yield call(getJwtToken);
    const rangeTarget = yield select(dateRangeNtt);
    const seasonSelectedNtt = yield select(selectedSeasonNtt);
    const propertyQuery = `AND property IN ('ntt', 'nttme')`;
    const propertyQueryWhere = `WHERE property IN ('ntt', 'nttme')`;
    const seasonQuery = (() => {
      if (
        seasonSelectedNtt.length > 0 &&
        seasonSelectedNtt[0].seasonId !== undefined
      ) {
        const ids = seasonSelectedNtt
          .map((s) => `'${s.seasonId}'`)
          .join(", ");
        return seasonSelectedNtt.length === 1
          ? `AND gameSpaceId = ${ids}`         // ids は "'id1'"
          : `AND (gameSpaceId IN (${ids}))`;     // ids は "'id1','id2',…"
      }
      return "";
    })();
    let sqlQueryDenchuPhotoShootTrend = {
      query: `
        SELECT DATE(convert_tz(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')) AS DAY, COUNT(denchuId)
        FROM DenchuPhotoShootDenchuEvtProd
        WHERE CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')
        BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59' ${propertyQuery} ${seasonQuery}
        GROUP BY DATE(convert_tz(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo'))
        ORDER BY logDate ASC;`,
      database: "KpiDashboard",
      type: "list",
    };

    if (action.payload === "hour") {
      sqlQueryDenchuPhotoShootTrend.query = `
        SELECT
          DATE_FORMAT(
              CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo'),
              '%Y-%m-%d %H:00'
          ) AS HOUR,
          COUNT(denchuId) AS denchu_count
        FROM
          DenchuPhotoShootDenchuEvtProd
        WHERE
          CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')
          BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59'
          ${propertyQuery} ${seasonQuery}
        GROUP BY
          HOUR
        ORDER BY
          HOUR ASC;
      `;
    }

    let sqlQueryPhotoShootUniqueTrend = {
      query: `
        SELECT DATE(convert_tz(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')) AS DAY, COUNT(DISTINCT uid) AS DAU
        FROM DenchuPhotoShootDenchuEvtProd
        WHERE CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')
        BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59'
        ${propertyQuery} ${seasonQuery}
        GROUP BY DATE(convert_tz(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo'))
        ORDER BY logDate ASC;`,
      database: "KpiDashboard",
      type: "list",
    };

    if (action.payload === "hour") {
      sqlQueryPhotoShootUniqueTrend.query = `
        SELECT
          DATE_FORMAT(
              CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo'),
              '%Y-%m-%d %H:00'
          ) AS HOUR,
          COUNT(DISTINCT uid) AS uid_count
        FROM
        DenchuPhotoShootDenchuEvtProd
        WHERE
            CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')
            BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59'
            ${propertyQuery} ${seasonQuery}
        GROUP BY
            HOUR
        ORDER BY
            HOUR ASC;
      `;
    }

    let sqlQueryNewUserDailyTrend = {
      query: `
        SELECT
          DATE(CONVERT_TZ(FROM_UNIXTIME(first_logDate/1000), 'UTC', 'Asia/Tokyo')) AS DAY,
          COUNT(*) AS new_unique_users
        FROM (
          SELECT
            uid,
            MIN(logDate) AS first_logDate,
            SUBSTRING_INDEX(
              GROUP_CONCAT(property ORDER BY logDate ASC),
              ',', 1
            ) AS first_property
          FROM DenchuPhotoShootDenchuEvtProd
          WHERE gameSpaceId = '${seasonSelectedNtt[0].seasonId}'
          GROUP BY uid
        ) AS first_events
        WHERE
          first_property IN ('ntt', 'nttme')
          AND first_logDate BETWEEN
            UNIX_TIMESTAMP(CONVERT_TZ('${rangeTarget[0]} 00:00:00', 'Asia/Tokyo','UTC')) * 1000
            AND UNIX_TIMESTAMP(CONVERT_TZ('${rangeTarget[1]} 23:59:59', 'Asia/Tokyo','UTC')) * 1000
        GROUP BY DAY
        ORDER BY DAY ASC;
      `,
      database: "KpiDashboard",
      type: "list",
    };

    if (action.payload === "hour") {
      sqlQueryNewUserDailyTrend.query = `
        SELECT
          DATE_FORMAT(
            CONVERT_TZ(FROM_UNIXTIME(first_logDate/1000), 'UTC', 'Asia/Tokyo'),
            '%Y-%m-%d %H:00'
          ) AS HOUR,
          COUNT(*) AS new_unique_users
        FROM (
          SELECT
            uid,
            MIN(logDate) AS first_logDate,
            SUBSTRING_INDEX(
              GROUP_CONCAT(property ORDER BY logDate ASC),
              ',', 1
            ) AS first_property
          FROM DenchuPhotoShootDenchuEvtProd
          WHERE gameSpaceId = '${seasonSelectedNtt[0].seasonId}'
          GROUP BY uid
        ) AS first_events
        WHERE
          first_property IN ('ntt', 'nttme')
          AND first_logDate BETWEEN
            UNIX_TIMESTAMP(CONVERT_TZ('${rangeTarget[0]} 00:00:00', 'Asia/Tokyo','UTC')) * 1000
            AND UNIX_TIMESTAMP(CONVERT_TZ('${rangeTarget[1]} 23:59:59', 'Asia/Tokyo','UTC')) * 1000
        GROUP BY HOUR
        ORDER BY HOUR ASC;
      `;
    }

    const [
      dataTempDenchuPhotoShootTrend,
      dataTempPhotoShootUniqueTrend,
      dataTempPhotoShootNewUserTrend,
    ] = yield all([
      call(
        getDataFromRDS,
        sqlQueryDenchuPhotoShootTrend,
        ENDPOINT.GET_DATA_USERS,
        jwtToken
      ),
      call(
        getDataFromRDS,
        sqlQueryPhotoShootUniqueTrend,
        ENDPOINT.GET_DATA_USERS,
        jwtToken
      ),
      call(
        getDataFromRDS,
        sqlQueryNewUserDailyTrend,
        ENDPOINT.GET_DATA_USERS,
        jwtToken
      ),
    ]);
    const dataDenchuPhotoShootTrend = JSON.parse(
      dataTempDenchuPhotoShootTrend.body
    );
    const dataPhotoShootUniqueTrend = JSON.parse(
      dataTempPhotoShootUniqueTrend.body
    );
    const dataPhotoShootNewUserTrend = JSON.parse(
      dataTempPhotoShootNewUserTrend.body
    );

    // Set xAxisDate
    let xAxisDate = [],
      dataDenchuArray = [],
      dataUniqueArray = [],
      dataNewUserArray = [],
      recordArray = [];
    const daysArray =
      action.payload === "day"
        ? H.FormatDateHelper.getDaysListBetweenDays(
            rangeTarget[0],
            rangeTarget[1]
          )
        : H.FormatDateHelper.getHoursListBetweenDays(
            rangeTarget[0],
            rangeTarget[1]
          );
    _.each(daysArray, function (data) {
      xAxisDate.push(data);
    });

    xAxisDate.forEach((date) => {
      const data = _.find(
        dataDenchuPhotoShootTrend,
        (item) => _.get(item, "[0].stringValue") === date
      );
      if (data) {
        dataDenchuArray.push(_.get(data, "[1].longValue"));
      } else {
        dataDenchuArray.push(0);
      }

      // Unique data
      const uniqueData = _.find(
        dataPhotoShootUniqueTrend,
        (item) => _.get(item, "[0].stringValue") === date
      );
      if (uniqueData) {
        dataUniqueArray.push(_.get(uniqueData, "[1].longValue"));
      } else {
        dataUniqueArray.push(0);
      }

      // New User data
      const newUserData = _.find(
        dataPhotoShootNewUserTrend,
        (item) => _.get(item, "[0].stringValue") === date
      );
      if (newUserData) {
        dataNewUserArray.push(_.get(newUserData, "[1].longValue"));
      } else {
        dataNewUserArray.push(0);
      }
    });

    const photoshootCountData = {
      date: xAxisDate,
      countDenchu: dataDenchuArray,
      unique: dataUniqueArray,
      newUser: dataNewUserArray,
    };
    recordArray.push(photoshootCountData);

    yield put(setPictreeDataPhotoShootTrendNtt(recordArray));
    yield put(setPageTopLoader(false));
  } catch (err) {
    console.log(err);
  }
}

export function* getPictreeDataPhootoShootKaisuTrend(action) {
  try {
    yield put(setPageTopLoader(true));
    const jwtToken = yield call(getJwtToken);
    const rangeTarget = yield select(dateRange);
    const propertyQuery = `AND (property = 'tepco' OR property IS NULL)`;

    // 1st time
    let sqlQueryDenchuKaisu1Trend = {
      query: `
        SELECT
            DATE(CONVERT_TZ(FROM_UNIXTIME(min_logDate / 1000), 'UTC', 'Asia/Tokyo')) AS date_only,
            COUNT(denchuId) AS first_time_appearance_count
        FROM (
            SELECT
                denchuId,
                MIN(logDate) AS min_logDate
            FROM DenchuPhotoShootDenchuEvtProd
            WHERE
                CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo') >= '2024-04-13 00:00:00'
                AND CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo') <= '${rangeTarget[1]} 23:59:59'
                ${propertyQuery}
            GROUP BY denchuId
        ) AS first_appearance_dates
        WHERE DATE(CONVERT_TZ(FROM_UNIXTIME(min_logDate / 1000), 'UTC', 'Asia/Tokyo')) BETWEEN '${rangeTarget[0]}' AND '${rangeTarget[1]}'
        GROUP BY date_only
        ORDER BY date_only;
      `,
      database: "KpiDashboard",
      type: "list",
    };

    if (action.payload == "hour") {
      sqlQueryDenchuKaisu1Trend.query = `
        SELECT
          DATE_FORMAT(
            CONVERT_TZ(FROM_UNIXTIME(first_occurrence_date / 1000), 'UTC', 'Asia/Tokyo'),
            '%Y-%m-%d %H:00'
          ) AS HOUR,
          COUNT(*) AS first_time_appearance_count
        FROM (
            SELECT
                denchuId,
                MIN(logDate) AS first_occurrence_date
            FROM DenchuPhotoShootDenchuEvtProd
            WHERE
              CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo') >= '2024-04-13 00:00:00'
              AND CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo') <= '${rangeTarget[1]} 23:59:59'
              ${propertyQuery}
            GROUP BY denchuId
        ) AS first_occurrences
        WHERE
          DATE(CONVERT_TZ(FROM_UNIXTIME(first_occurrence_date / 1000), 'UTC', 'Asia/Tokyo')) BETWEEN '${rangeTarget[0]}' AND '${rangeTarget[1]}'
        GROUP BY HOUR
        ORDER BY HOUR;
      `;
    }

    // 2nd time
    let sqlQueryDenchuKaisu2Trend = {
      query: `
        SELECT
            DATE(CONVERT_TZ(FROM_UNIXTIME(second_occurrence_date / 1000), 'UTC', 'Asia/Tokyo')) AS date_only,
            COUNT(*) AS second_time_appearance_count
        FROM (
            SELECT
                denchuId,
                logDate AS second_occurrence_date
            FROM (
                SELECT
                    denchuId,
                    logDate,
                    @row_num := IF(@current_denchu = denchuId, @row_num + 1, 1) AS row_num,
                    @current_denchu := denchuId
                FROM
                    DenchuPhotoShootDenchuEvtProd,
                    (SELECT @row_num := 0, @current_denchu := '') AS vars
                WHERE
                    CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo') >= '2024-04-13 00:00:00'
                    AND CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo') <= '${rangeTarget[1]} 23:59:59'
                    ${propertyQuery}
                ORDER BY
                    denchuId, logDate
            ) AS ranked
            WHERE
                row_num = 2
        ) AS second_occurrences
        WHERE
            DATE(CONVERT_TZ(FROM_UNIXTIME(second_occurrence_date / 1000), 'UTC', 'Asia/Tokyo')) BETWEEN '${rangeTarget[0]}' AND '${rangeTarget[1]}'
        GROUP BY date_only
        ORDER BY date_only;
      `,
      database: "KpiDashboard",
      type: "list",
    };

    if (action.payload == "hour") {
      sqlQueryDenchuKaisu2Trend.query = `
        SELECT
            DATE_FORMAT(CONVERT_TZ(FROM_UNIXTIME(second_occurrence_date / 1000), 'UTC', 'Asia/Tokyo'), '%Y-%m-%d %H:00') AS hour_only,
            COUNT(*) AS second_time_appearance_count
        FROM (
            SELECT
                denchuId,
                MIN(second_logDate) AS second_occurrence_date
            FROM (
                SELECT
                    dp1.denchuId,
                    dp2.logDate AS second_logDate
                FROM
                    (SELECT
                        denchuId,
                        MIN(logDate) AS first_occurrence_date
                    FROM
                        DenchuPhotoShootDenchuEvtProd
                    WHERE
                        CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo') >= '2024-04-13 00:00:00'
                        AND CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo') <= '${rangeTarget[1]} 23:59:59'
                        ${propertyQuery}
                    GROUP BY
                        denchuId) AS dp1
                JOIN DenchuPhotoShootDenchuEvtProd dp2
                ON dp1.denchuId = dp2.denchuId
                WHERE
                    dp2.logDate > dp1.first_occurrence_date
                GROUP BY
                    dp1.denchuId, dp2.logDate
                HAVING
                    COUNT(dp2.denchuId) = 2
            ) AS second_occurrences
            GROUP BY denchuId
        ) AS occurrences
        WHERE
            DATE(CONVERT_TZ(FROM_UNIXTIME(second_occurrence_date / 1000), 'UTC', 'Asia/Tokyo')) BETWEEN '${rangeTarget[0]}' AND '${rangeTarget[1]}'
        GROUP BY hour_only
        ORDER BY hour_only;
      `;
    }

    // 3 time
    const sqlQueryDenchuKaisu3Trend = {
      query: `
        SELECT
            DATE(CONVERT_TZ(FROM_UNIXTIME(third_occurrence_date / 1000), 'UTC', 'Asia/Tokyo')) AS date_only,
            COUNT(*) AS third_time_appearance_count
        FROM (
            SELECT
                denchuId,
                logDate AS third_occurrence_date
            FROM (
                SELECT
                    denchuId,
                    logDate,
                    @row_num := IF(@current_denchu = denchuId, @row_num + 1, 1) AS row_num,
                    @current_denchu := denchuId
                FROM
                    DenchuPhotoShootDenchuEvtProd,
                    (SELECT @row_num := 0, @current_denchu := '') AS vars
                WHERE
                    CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo') >= '2024-04-13 00:00:00'
                    AND CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo') <= '${rangeTarget[1]} 23:59:59'
                    ${propertyQuery}
                ORDER BY
                    denchuId, logDate
            ) AS ranked
            WHERE
                row_num = 3
        ) AS third_occurrences
        WHERE
          DATE(CONVERT_TZ(FROM_UNIXTIME(third_occurrence_date / 1000), 'UTC', 'Asia/Tokyo')) BETWEEN '${rangeTarget[0]}' AND '${rangeTarget[1]}'
        GROUP BY date_only
        ORDER BY date_only;
      `,
      database: "KpiDashboard",
      type: "list",
    };

    if (action.payload == "hour") {
      sqlQueryDenchuKaisu3Trend.query = `
        SELECT
            DATE_FORMAT(CONVERT_TZ(FROM_UNIXTIME(third_occurrence_date / 1000), 'UTC', 'Asia/Tokyo'), '%Y-%m-%d %H:00') AS hour_only,
            COUNT(*) AS third_time_appearance_count
        FROM (
            SELECT
                denchuId,
                logDate AS third_occurrence_date
            FROM (
                SELECT
                    denchuId,
                    logDate,
                    @row_num := IF(@current_denchu = denchuId, @row_num + 1, 1) AS row_num,
                    @current_denchu := denchuId
                FROM
                    DenchuPhotoShootDenchuEvtProd,
                    (SELECT @row_num := 0, @current_denchu := '') AS vars
                WHERE
                    CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo') >= '2024-04-13 00:00:00'
                    AND CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo') <= '${rangeTarget[1]} 23:59:59'
                    ${propertyQuery}
                ORDER BY
                    denchuId, logDate
            ) AS ranked
            WHERE
                row_num = 3
        ) AS third_occurrences
        WHERE
            DATE(CONVERT_TZ(FROM_UNIXTIME(third_occurrence_date / 1000), 'UTC', 'Asia/Tokyo')) BETWEEN '${rangeTarget[0]}' AND '${rangeTarget[1]}'
        GROUP BY hour_only
        ORDER BY hour_only;
      `;
    }

    // 4 time
    const sqlQueryDenchuKaisu4Trend = {
      query: `
        SELECT
          DATE(CONVERT_TZ(FROM_UNIXTIME(fourth_occurrence_date / 1000), 'UTC', 'Asia/Tokyo')) AS date_only,
          COUNT(*) AS fourth_time_appearance_count
        FROM (
            SELECT
                denchuId,
                logDate AS fourth_occurrence_date
            FROM (
                SELECT
                    denchuId,
                    logDate,
                    @row_num := IF(@current_denchu = denchuId, @row_num + 1, 1) AS row_num,
                    @current_denchu := denchuId
                FROM
                    DenchuPhotoShootDenchuEvtProd,
                    (SELECT @row_num := 0, @current_denchu := '') AS vars
                WHERE
                    CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo') >= '2024-04-13 00:00:00'
                    AND CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo') <= '${rangeTarget[1]} 23:59:59'
                    ${propertyQuery}
                ORDER BY
                    denchuId, logDate
            ) AS ranked
            WHERE
                row_num = 4
        ) AS fourth_occurrences
        WHERE
          DATE(CONVERT_TZ(FROM_UNIXTIME(fourth_occurrence_date / 1000), 'UTC', 'Asia/Tokyo')) BETWEEN '${rangeTarget[0]}' AND '${rangeTarget[1]}'
        GROUP BY date_only
        ORDER BY date_only;
      `,
      database: "KpiDashboard",
      type: "list",
    };

    if (action.payload == "hour") {
      sqlQueryDenchuKaisu4Trend.query = `
        SELECT
            DATE_FORMAT(CONVERT_TZ(FROM_UNIXTIME(third_occurrence_date / 1000), 'UTC', 'Asia/Tokyo'), '%Y-%m-%d %H:00') AS hour_only,
            COUNT(*) AS third_time_appearance_count
        FROM (
            SELECT
                denchuId,
                logDate AS third_occurrence_date
            FROM (
                SELECT
                    denchuId,
                    logDate,
                    @row_num := IF(@current_denchu = denchuId, @row_num + 1, 1) AS row_num,
                    @current_denchu := denchuId
                FROM
                    DenchuPhotoShootDenchuEvtProd,
                    (SELECT @row_num := 0, @current_denchu := '') AS vars
                WHERE
                    CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo') >= '2024-04-13 00:00:00'
                    AND CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo') <= '${rangeTarget[1]} 23:59:59'
                    ${propertyQuery}
                ORDER BY
                    denchuId, logDate
            ) AS ranked
            WHERE
                row_num = 4
        ) AS third_occurrences
        WHERE
            DATE(CONVERT_TZ(FROM_UNIXTIME(third_occurrence_date / 1000), 'UTC', 'Asia/Tokyo')) BETWEEN '${rangeTarget[0]}' AND '${rangeTarget[1]}'
        GROUP BY hour_only
        ORDER BY hour_only;
      `;
    }

    // 5 time
    const sqlQueryDenchuKaisu5Trend = {
      query: `
        SELECT
          DATE(CONVERT_TZ(FROM_UNIXTIME(nth_occurrence_date / 1000), 'UTC', 'Asia/Tokyo')) AS date_only,
          COUNT(*) AS nth_time_appearance_count
        FROM (
            SELECT
                denchuId,
                logDate AS nth_occurrence_date
            FROM (
                SELECT
                    denchuId,
                    logDate,
                    @row_num := IF(@current_denchu = denchuId, @row_num + 1, 1) AS row_num,
                    @current_denchu := denchuId
                FROM
                    DenchuPhotoShootDenchuEvtProd,
                    (SELECT @row_num := 0, @current_denchu := '') AS vars
                WHERE
                    CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo') >= '2024-04-13 00:00:00'
                    AND CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo') <= '${rangeTarget[1]} 23:59:59'
                    ${propertyQuery}
                ORDER BY
                    denchuId, logDate
            ) AS ranked
            WHERE
                row_num = 5
        ) AS fourth_occurrences
        WHERE
          DATE(CONVERT_TZ(FROM_UNIXTIME(nth_occurrence_date / 1000), 'UTC', 'Asia/Tokyo')) BETWEEN '${rangeTarget[0]}' AND '${rangeTarget[1]}'
        GROUP BY date_only
        ORDER BY date_only;
      `,
      database: "KpiDashboard",
      type: "list",
    };

    if (action.payload == "hour") {
      sqlQueryDenchuKaisu5Trend.query = `
        SELECT
            DATE_FORMAT(CONVERT_TZ(FROM_UNIXTIME(third_occurrence_date / 1000), 'UTC', 'Asia/Tokyo'), '%Y-%m-%d %H:00') AS hour_only,
            COUNT(*) AS third_time_appearance_count
        FROM (
            SELECT
                denchuId,
                logDate AS third_occurrence_date
            FROM (
                SELECT
                    denchuId,
                    logDate,
                    @row_num := IF(@current_denchu = denchuId, @row_num + 1, 1) AS row_num,
                    @current_denchu := denchuId
                FROM
                    DenchuPhotoShootDenchuEvtProd,
                    (SELECT @row_num := 0, @current_denchu := '') AS vars
                WHERE
                    CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo') >= '2024-04-13 00:00:00'
                    AND CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo') <= '${rangeTarget[1]} 23:59:59'
                    ${propertyQuery}
                ORDER BY
                    denchuId, logDate
            ) AS ranked
            WHERE
                row_num = 5
        ) AS third_occurrences
        WHERE
            DATE(CONVERT_TZ(FROM_UNIXTIME(third_occurrence_date / 1000), 'UTC', 'Asia/Tokyo')) BETWEEN '${rangeTarget[0]}' AND '${rangeTarget[1]}'
        GROUP BY hour_only
        ORDER BY hour_only;
      `;
    }

    // 6+ times
    const sqlQueryDenchuKaisu6Trend = {
      query: `
        SELECT
          DATE(CONVERT_TZ(FROM_UNIXTIME(nth_occurrence_date / 1000), 'UTC', 'Asia/Tokyo')) AS date_only,
          COUNT(*) AS nth_time_appearance_count
        FROM (
            SELECT
                denchuId,
                logDate AS nth_occurrence_date
            FROM (
                SELECT
                    denchuId,
                    logDate,
                    @row_num := IF(@current_denchu = denchuId, @row_num + 1, 1) AS row_num,
                    @current_denchu := denchuId
                FROM
                    DenchuPhotoShootDenchuEvtProd,
                    (SELECT @row_num := 0, @current_denchu := '') AS vars
                WHERE
                    CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo') >= '2024-04-13 00:00:00'
                    AND CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo') <= '${rangeTarget[1]} 23:59:59'
                    ${propertyQuery}
                ORDER BY
                    denchuId, logDate
            ) AS ranked
            WHERE
                row_num > 5
        ) AS fourth_occurrences
        WHERE
          DATE(CONVERT_TZ(FROM_UNIXTIME(nth_occurrence_date / 1000), 'UTC', 'Asia/Tokyo')) BETWEEN '${rangeTarget[0]}' AND '${rangeTarget[1]}'
        GROUP BY date_only
        ORDER BY date_only;
      `,
      database: "KpiDashboard",
      type: "list",
    };

    if (action.payload == "hour") {
      sqlQueryDenchuKaisu6Trend.query = `
        SELECT
            DATE_FORMAT(CONVERT_TZ(FROM_UNIXTIME(third_occurrence_date / 1000), 'UTC', 'Asia/Tokyo'), '%Y-%m-%d %H:00') AS hour_only,
            COUNT(*) AS third_time_appearance_count
        FROM (
            SELECT
                denchuId,
                logDate AS third_occurrence_date
            FROM (
                SELECT
                    denchuId,
                    logDate,
                    @row_num := IF(@current_denchu = denchuId, @row_num + 1, 1) AS row_num,
                    @current_denchu := denchuId
                FROM
                    DenchuPhotoShootDenchuEvtProd,
                    (SELECT @row_num := 0, @current_denchu := '') AS vars
                WHERE
                    CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo') >= '2024-04-13 00:00:00'
                    AND CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo') <= '${rangeTarget[1]} 23:59:59'
                    ${propertyQuery}
                ORDER BY
                    denchuId, logDate
            ) AS ranked
            WHERE
                row_num > 5
        ) AS third_occurrences
        WHERE
            DATE(CONVERT_TZ(FROM_UNIXTIME(third_occurrence_date / 1000), 'UTC', 'Asia/Tokyo')) BETWEEN '${rangeTarget[0]}' AND '${rangeTarget[1]}'
        GROUP BY hour_only
        ORDER BY hour_only;
      `;
    }

    const [
      dataTempDenchuKaisu1,
      dataTempDenchuKaisu2,
      dataTempDenchuKaisu3,
      dataTempDenchuKaisu4,
      dataTempDenchuKaisu5,
      dataTempDenchuKaisu6,
    ] = yield all([
      call(
        getDataFromRDS,
        sqlQueryDenchuKaisu1Trend,
        ENDPOINT.GET_DATA_USERS,
        jwtToken
      ),
      call(
        getDataFromRDS,
        sqlQueryDenchuKaisu2Trend,
        ENDPOINT.GET_DATA_USERS,
        jwtToken
      ),
      call(
        getDataFromRDS,
        sqlQueryDenchuKaisu3Trend,
        ENDPOINT.GET_DATA_USERS,
        jwtToken
      ),
      call(
        getDataFromRDS,
        sqlQueryDenchuKaisu4Trend,
        ENDPOINT.GET_DATA_USERS,
        jwtToken
      ),
      call(
        getDataFromRDS,
        sqlQueryDenchuKaisu5Trend,
        ENDPOINT.GET_DATA_USERS,
        jwtToken
      ),
      call(
        getDataFromRDS,
        sqlQueryDenchuKaisu6Trend,
        ENDPOINT.GET_DATA_USERS,
        jwtToken
      ),
    ]);
    const dataDenchuKaisuTrend1 = JSON.parse(dataTempDenchuKaisu1.body);
    const dataDenchuKaisuTrend2 = JSON.parse(dataTempDenchuKaisu2.body);
    const dataDenchuKaisuTrend3 = JSON.parse(dataTempDenchuKaisu3.body);
    const dataDenchuKaisuTrend4 = JSON.parse(dataTempDenchuKaisu4.body);
    const dataDenchuKaisuTrend5 = JSON.parse(dataTempDenchuKaisu5.body);
    const dataDenchuKaisuTrend6 = JSON.parse(dataTempDenchuKaisu6.body);

    // aggregate data
    // Set xAxisDate
    let xAxisDate = [],
      dataFirstArray = [],
      dataTwoArray = [],
      dataThreeArray = [],
      dataFourArray = [],
      dataFiveArray = [],
      dataSixArray = [];
    const daysArray =
      action.payload === "day"
        ? H.FormatDateHelper.getDaysListBetweenDays(
            rangeTarget[0],
            rangeTarget[1]
          )
        : H.FormatDateHelper.getHoursListBetweenDays(
            rangeTarget[0],
            rangeTarget[1]
          );
    _.each(daysArray, function (data) {
      xAxisDate.push(data);
    });

    xAxisDate.forEach((date) => {
      // 1st time
      const data1st = _.find(
        dataDenchuKaisuTrend1,
        (item) => _.get(item, "[0].stringValue") === date
      );
      if (data1st) {
        dataFirstArray.push(_.get(data1st, "[1].longValue"));
      } else {
        dataFirstArray.push(0);
      }

      // 2 times
      const dataTwo = _.find(
        dataDenchuKaisuTrend2,
        (item) => _.get(item, "[0].stringValue") === date
      );
      if (dataTwo) {
        dataTwoArray.push(_.get(dataTwo, "[1].longValue"));
      } else {
        dataTwoArray.push(0);
      }

      // 3 times
      const dataThree = _.find(
        dataDenchuKaisuTrend3,
        (item) => _.get(item, "[0].stringValue") === date
      );
      if (dataThree) {
        dataThreeArray.push(_.get(dataThree, "[1].longValue"));
      } else {
        dataThreeArray.push(0);
      }

      // 4 times
      const dataFour = _.find(
        dataDenchuKaisuTrend4,
        (item) => _.get(item, "[0].stringValue") === date
      );
      if (dataFour) {
        dataFourArray.push(_.get(dataFour, "[1].longValue"));
      } else {
        dataFourArray.push(0);
      }

      // 5 times
      const dataFive = _.find(
        dataDenchuKaisuTrend5,
        (item) => _.get(item, "[0].stringValue") === date
      );
      if (dataFive) {
        dataFiveArray.push(_.get(dataFive, "[1].longValue"));
      } else {
        dataFiveArray.push(0);
      }

      // 6 times
      const dataSix = _.find(
        dataDenchuKaisuTrend6,
        (item) => _.get(item, "[0].stringValue") === date
      );
      if (dataSix) {
        dataSixArray.push(_.get(dataSix, "[1].longValue"));
      } else {
        dataSixArray.push(0);
      }
    });

    const photoshootCountData = {
      date: xAxisDate,
      series: [
        dataFirstArray,
        dataTwoArray,
        dataThreeArray,
        dataFourArray,
        dataFiveArray,
        dataSixArray,
      ],
    };
    const recordArray = [photoshootCountData];
    yield put(setPictreeDataPhotoDenchuKaisuTrend(recordArray));
    yield put(setPageTopLoader(false));
  } catch (err) {
    console.log(err);
  }
}

export function* getPictreeDataPhotoShootMap(action) {
  try {
    yield put(setPageTopLoader(true));
    const jwtToken = yield call(getJwtToken);
    const rangeTarget = yield select(dateRange);
    const seasonSelected = yield select(selectedSeason);
    const seasonName = findSeason(rangeTarget[1]);
    const propertyQuery = `AND (property = 'tepco' OR property IS NULL)`;

    let sqlCountMapData = {
      query: `
        SELECT COUNT(*)
        FROM DenchuPhotoShootDenchuEvtProd
        WHERE CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo') BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59' ${propertyQuery};`,
      database: "KpiDashboard",
      type: "list",
    };

    const [dataPhotoCount] = yield all([
      call(getDataFromRDS, sqlCountMapData, ENDPOINT.GET_DATA_USERS, jwtToken),
    ]);
    const countPhoto = JSON.parse(dataPhotoCount.body);

    let recordArray = [],
      eachData = {};

    if (action.payload.filter === "taken") {
      const LIMIT = 1500;
      let offset = 0;

      while (offset < countPhoto[0][0]["longValue"]) {
        let sqlQueryCountPhotoDenchu = {
          query: `
          SELECT *
          FROM DenchuPhotoShootDenchuEvtProd
          WHERE CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo') BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59' ${propertyQuery}
          ORDER BY logDate DESC LIMIT ${LIMIT} OFFSET ${offset};`,
          database: "KpiDashboard",
          type: "list",
        };

        const [dataPhotoDenchu] = yield all([
          call(
            getDataFromRDS,
            sqlQueryCountPhotoDenchu,
            ENDPOINT.GET_DATA_USERS,
            jwtToken
          ),
        ]);
        const countPhotoDenchu = JSON.parse(dataPhotoDenchu.body);
        console.log("LOG data countPhotoDenchu:", countPhotoDenchu.length);
        _.each(countPhotoDenchu, function (data, index) {
          eachData.user = data[2]["stringValue"];
          eachData.asset_id = data[4]["stringValue"];
          eachData.latitude = parseFloat(data[5]["stringValue"]);
          eachData.longitude = parseFloat(data[6]["stringValue"]);
          eachData.parts = data[7]["stringValue"];
          eachData.picCount = data[8]["longValue"];
          eachData.dateTime = moment(data[14]["longValue"])
            .tz("Asia/Tokyo")
            .format("YYYY/MM/DD hh:mm A");
          recordArray.push(eachData);
          eachData = {};
        });

        offset += LIMIT;
      }
    } else if (action.payload.filter === "untaken") {
      const seasonId = seasonSelected[0]["seasonId"];

      let sqlQueryCountPhotoDenchu = {
        query: `
          SELECT *
          FROM power_asset AS pa
          INNER JOIN power_asset_detail_of_tepco AS pad
              ON pa.id = pad.power_asset_id
          WHERE pa.id IN (
              SELECT power_asset_id
              FROM power_asset_state
              WHERE game_space_id = '${seasonId}'
              AND power_asset_id NOT IN (
                  SELECT DISTINCT power_asset_id
                  FROM review_request
                  WHERE game_space_id = '${seasonId}'
                  AND status = 'APPROVED'
              )
          );
        `,
        database: "KpiDashboard",
        type: "list",
      };

      const [tempMapUntaken] = yield all([
        call(
          getDataFromSxi,
          sqlQueryCountPhotoDenchu,
          ENDPOINT.GET_DATA_SXI_DENCHU,
          jwtToken
        ),
      ]);

      _.each(tempMapUntaken, function (data, index) {
        eachData.user = "--";
        eachData.asset_id = data["power_asset_id"];
        eachData.latitude = parseFloat(data["latitude"]);
        eachData.longitude = parseFloat(data["longitude"]);
        eachData.parts = "0";
        eachData.picCount = 0;
        eachData.dateTime = "n/a";
        recordArray.push(eachData);
        eachData = {};
      });
    }

    yield put(setPhotoShootMapData(recordArray));
    yield put(setPageTopLoader(false));
  } catch (err) {
    console.log(err);
  }
}

export function* getPictreeDataPhotoShootMapTepcoSxiOptimized(action) {
  try {
    yield put(setPageTopLoader(true));
    const jwtToken = yield call(getJwtToken);
    const LIMIT = 10000;
    let offset = 0;

    const seasonSelected = yield select(selectedSeason);
    if (seasonSelected.length === 0) {
      yield put(setPageTopLoader(false));
      return;
    }

    const seasonId = seasonSelected[0]["seasonId"];
    const assetSubTypeSelected = yield select(selectedMapAssetSubType);

    let sqlQueryGetAssetSubType;
    sqlQueryGetAssetSubType = {
      query: `
        SELECT pa.sub_type
        FROM power_asset AS pa
        INNER JOIN power_asset_detail_of_tepco AS pad
            ON pa.id = pad.power_asset_id
        INNER JOIN power_asset_state pas
            ON pa.id = pas.power_asset_id
        INNER JOIN review_request rr
            ON pa.id = rr.power_asset_id
            AND rr.game_space_id = '${seasonId}'
        WHERE pas.game_space_id = '${seasonId}'
        AND rr.status = 'APPROVED'
        GROUP BY pa.sub_type
      `,
      database: "KpiDashboard",
      type: "list",
    };
    const [subTypeTemp] = yield all([
      call(
        getDataFromSxi,
        sqlQueryGetAssetSubType,
        ENDPOINT.GET_DATA_SXI_DENCHU,
        jwtToken
      ),
    ]);

    if (subTypeTemp.length > 0) {
      // let config of seasonConfig.seasonConfig
      const assetSubType = assetConfig.assetSubType;
      let subTypeOption = [{ name: "全て", value: "all" }];
      _.each(subTypeTemp, function (data, index) {
        subTypeOption.push({
          name:
            assetSubType[data["sub_type"]] !== undefined
              ? assetSubType[data["sub_type"]]
              : data["sub_type"],
          value: data["sub_type"],
        });
      });
      yield put(setPictreeMapSubTypeOption(subTypeOption));
    }

    let recordArray = [];
    let subTypeWhereQuery = ``;
    if (assetSubTypeSelected !== "all") {
      subTypeWhereQuery = `AND pa.sub_type = '${assetSubTypeSelected}'`;
    }

    let sqlCountQuery;
    if (action.payload.filter === "taken") {
      sqlCountQuery = {
        query: `
          SELECT COUNT(DISTINCT(pa.id)) AS count
          FROM power_asset AS pa
          INNER JOIN power_asset_detail_of_tepco AS pad
              ON pa.id = pad.power_asset_id
          INNER JOIN power_asset_state pas
              ON pa.id = pas.power_asset_id
          INNER JOIN review_request rr
              ON pa.id = rr.power_asset_id
              AND rr.game_space_id = '${seasonId}'
          WHERE pas.game_space_id = '${seasonId}'
          AND rr.status = 'APPROVED'
          ${subTypeWhereQuery}
        `,
        database: "KpiDashboard",
        type: "list",
      };
    } else if (action.payload.filter === "untaken") {
      sqlCountQuery = {
        query: `
          SELECT COUNT(DISTINCT(pa.id)) AS count
          FROM power_asset AS pa
          INNER JOIN power_asset_detail_of_tepco AS pad
              ON pa.id = pad.power_asset_id
          INNER JOIN power_asset_state pas
              ON pa.id = pas.power_asset_id
          LEFT JOIN review_request rr
              ON pa.id = rr.power_asset_id
              AND rr.game_space_id = '${seasonId}'
              AND rr.status = 'APPROVED'
          WHERE pas.game_space_id = '${seasonId}'
          AND rr.power_asset_id IS NULL
          ${subTypeWhereQuery}
        `,
        database: "KpiDashboard",
        type: "list",
      };
    } else if (action.payload.filter === "taken+untaken") {
      sqlCountQuery = {
        query: `
          SELECT COUNT(*) AS count
          FROM power_asset AS pa
          INNER JOIN power_asset_detail_of_tepco AS pad
              ON pa.id = pad.power_asset_id
          INNER JOIN power_asset_state pas
              ON pa.id = pas.power_asset_id
          LEFT JOIN review_request rr
              ON pa.id = rr.power_asset_id
              AND rr.game_space_id = '${seasonId}'
              AND rr.status != 'APPROVED'
          WHERE pas.game_space_id = '${seasonId}'
          ${subTypeWhereQuery}
        `,
        database: "KpiDashboard",
        type: "list",
      };
    }

    // ✅ データ総数を取得
    const [dataCount] = yield all([
      call(
        getDataFromSxi,
        sqlCountQuery,
        ENDPOINT.GET_DATA_SXI_DENCHU,
        jwtToken
      ),
    ]);
    const totalCount = dataCount[0]["count"];

    // ✅ 並列リクエスト用の配列作成
    let requests = [];
    while (offset < totalCount) {
      const sqlQuery = {
        query: `
          ${
            action.payload.filter === "taken"
              ? `
              SELECT *
              FROM power_asset AS pa
              INNER JOIN power_asset_detail_of_tepco AS pad
                  ON pa.id = pad.power_asset_id
              INNER JOIN power_asset_state pas
                  ON pa.id = pas.power_asset_id
              INNER JOIN review_request rr
                  ON pa.id = rr.power_asset_id
                  AND rr.game_space_id = '${seasonId}'
              WHERE pas.game_space_id = '${seasonId}'
              AND rr.status = 'APPROVED'
              ${subTypeWhereQuery}
              GROUP BY pa.id
              LIMIT ${LIMIT} OFFSET ${offset};
            `
              : `
              SELECT *
              FROM power_asset AS pa
              INNER JOIN power_asset_detail_of_tepco AS pad
                  ON pa.id = pad.power_asset_id
              INNER JOIN power_asset_state pas
                  ON pa.id = pas.power_asset_id
              LEFT JOIN review_request rr
                  ON pa.id = rr.power_asset_id
                  AND rr.game_space_id = '${seasonId}'
                  AND rr.status = 'APPROVED'
              WHERE pas.game_space_id = '${seasonId}'
              AND rr.power_asset_id IS NULL
              ${subTypeWhereQuery}
              GROUP BY pa.id
              LIMIT ${LIMIT} OFFSET ${offset};
            `
          }
        `,
        database: "KpiDashboard",
        type: "list",
      };
      requests.push(
        call(getDataFromSxi, sqlQuery, ENDPOINT.GET_DATA_SXI_DENCHU, jwtToken)
      );
      offset += LIMIT;
    }

    // ✅ 並列実行（🔥全てのリクエストを一気に発火！）
    const results = yield all(requests);

    // ✅ データを統合
    results.forEach((dataBatch) => {
      dataBatch.forEach((data) => {
        recordArray.push({
          id: data["power_asset_id"],
          asset_id: data["power_asset_id"],
          latitude: parseFloat(data["latitude"]),
          longitude: parseFloat(data["longitude"]),
          sign_number: data["sign_number"],
          sign_name: data["sign_name"],
          place_code: data["place_code"],
        });
      });
    });

    yield put(setPhotoShootMapData(recordArray));
    yield put(setPageTopLoader(false));
  } catch (err) {
    console.log(err);
  }
}

export function* getPictreeDataPhotoShootMapTepcoSxiOptimized2(action) {
  try {
    yield put(setPageTopLoader(true));
    yield put(setPhotoShootMapData([]));

    const jwtToken = yield call(getJwtToken);
    const LIMIT = 10000;

    // ---- 共通（シーズン / サブタイプ） ------------------------------------
    const seasonSelected = yield select(selectedSeason);
    if (!seasonSelected || seasonSelected.length === 0) {
      yield put(setPageTopLoader(false));
      return;
    }
    const seasonId = seasonSelected[0]['seasonId'];

    const assetSubTypeSelected = yield select(selectedMapAssetSubType);

    // サブタイプ選択肢
    const sqlQueryGetAssetSubType = {
      query: `
        SELECT pa.sub_type
        FROM power_asset AS pa
        INNER JOIN power_asset_detail_of_tepco AS pad
            ON pa.id = pad.power_asset_id
        INNER JOIN power_asset_state pas
            ON pa.id = pas.power_asset_id
        INNER JOIN review_request rr
            ON pa.id = rr.power_asset_id
           AND rr.game_space_id = '${seasonId}'
        WHERE pas.game_space_id = '${seasonId}'
          AND rr.status = 'APPROVED'
        GROUP BY pa.sub_type
      `,
      database: 'KpiDashboard',
      type: 'list',
    };

    const [subTypeTemp] = yield all([
      call(getDataFromSxi, sqlQueryGetAssetSubType, ENDPOINT.GET_DATA_SXI_DENCHU, jwtToken),
    ]);

    if (subTypeTemp && subTypeTemp.length > 0) {
      const assetSubType = assetConfig.assetSubType;
      const subTypeOption = [{ name: '全て', value: 'all' }].concat(
        subTypeTemp.map((d) => ({
          name: assetSubType[d['sub_type']] !== undefined ? assetSubType[d['sub_type']] : d['sub_type'],
          value: d['sub_type'],
        }))
      );
      yield put(setPictreeMapSubTypeOption(subTypeOption));
    }

    const subTypeWhereQuery =
      assetSubTypeSelected !== 'all' ? `AND pa.sub_type = '${assetSubTypeSelected}'` : ``;

    // ---- ヘルパー（件数SQL） ----------------------------------------------
    const buildCountQuery = (kind) => {
      if (kind === 'taken') {
        return {
          query: `
            SELECT COUNT(DISTINCT pa.id) AS count
            FROM power_asset pa
            INNER JOIN power_asset_detail_of_tepco pad ON pa.id = pad.power_asset_id
            INNER JOIN power_asset_state pas ON pa.id = pas.power_asset_id
            INNER JOIN review_request rr
              ON pa.id = rr.power_asset_id
             AND rr.game_space_id = '${seasonId}'
            WHERE pas.game_space_id = '${seasonId}'
              AND rr.status = 'APPROVED'
              ${subTypeWhereQuery}
          `,
          database: 'KpiDashboard',
          type: 'list',
        };
      }
      // untaken
      return {
        query: `
          SELECT COUNT(DISTINCT pa.id) AS count
          FROM power_asset pa
          INNER JOIN power_asset_detail_of_tepco pad ON pa.id = pad.power_asset_id
          INNER JOIN power_asset_state pas ON pa.id = pas.power_asset_id
          LEFT JOIN review_request rr
            ON pa.id = rr.power_asset_id
           AND rr.game_space_id = '${seasonId}'
           AND rr.status = 'APPROVED'
          WHERE pas.game_space_id = '${seasonId}'
            AND rr.power_asset_id IS NULL
            ${subTypeWhereQuery}
        `,
        database: 'KpiDashboard',
        type: 'list',
      };
    };

    // ---- ヘルパー（ページSQL） --------------------------------------------
    const buildPageQuery = (kind, limit, offset) => {
      if (kind === 'taken') {
        return {
          query: `
            SELECT pa.id AS power_asset_id, pad.sign_number, pad.sign_name, pad.place_code,
                   pa.latitude, pa.longitude
            FROM power_asset pa
            INNER JOIN power_asset_detail_of_tepco pad ON pa.id = pad.power_asset_id
            INNER JOIN power_asset_state pas ON pa.id = pas.power_asset_id
            INNER JOIN review_request rr
              ON pa.id = rr.power_asset_id
             AND rr.game_space_id = '${seasonId}'
            WHERE pas.game_space_id = '${seasonId}'
              AND rr.status = 'APPROVED'
              ${subTypeWhereQuery}
            GROUP BY pa.id
            LIMIT ${limit} OFFSET ${offset}
          `,
          database: 'KpiDashboard',
          type: 'list',
        };
      }
      // untaken
      return {
        query: `
          SELECT pa.id AS power_asset_id, pad.sign_number, pad.sign_name, pad.place_code,
                 pa.latitude, pa.longitude
          FROM power_asset pa
          INNER JOIN power_asset_detail_of_tepco pad ON pa.id = pad.power_asset_id
          INNER JOIN power_asset_state pas ON pa.id = pas.power_asset_id
          LEFT JOIN review_request rr
            ON pa.id = rr.power_asset_id
           AND rr.game_space_id = '${seasonId}'
           AND rr.status = 'APPROVED'
          WHERE pas.game_space_id = '${seasonId}'
            AND rr.power_asset_id IS NULL
            ${subTypeWhereQuery}
          GROUP BY pa.id
          LIMIT ${limit} OFFSET ${offset}
        `,
        database: 'KpiDashboard',
        type: 'list',
      };
    };

    // ---- ヘルパー（1種類を全件取得） --------------------------------------
    function* fetchAll(kind) {
      // 1) 件数
      const [cntRes] = yield all([
        call(getDataFromSxi, buildCountQuery(kind), ENDPOINT.GET_DATA_SXI_DENCHU, jwtToken),
      ]);
      const total = Number(cntRes && cntRes[0] && cntRes[0].count ? cntRes[0].count : 0);
      if (!total) return [];

      // 2) ページングを並列実行
      const calls = [];
      for (let offset = 0; offset < total; offset += LIMIT) {
        calls.push(
          call(
            getDataFromSxi,
            buildPageQuery(kind, LIMIT, offset),
            ENDPOINT.GET_DATA_SXI_DENCHU,
            jwtToken
          )
        );
      }
      const pages = yield all(calls);

      // 3) 整形
      const flat = [];
      pages.forEach((batch) => {
        batch.forEach((row) => {
          flat.push({
            id: row['power_asset_id'],
            asset_id: row['power_asset_id'],
            latitude: parseFloat(row['latitude']),
            longitude: parseFloat(row['longitude']),
            sign_number: row['sign_number'],
            sign_name: row['sign_name'],
            place_code: row['place_code'],
          });
        });
      });
      return flat;
    }

    // ---- 実行（撮影済み＋未撮影を並列 / 2D配列で返却） ----------------------
    const filter = action && action.payload && action.payload.filter;

    if (filter === 'taken+untaken') {
      const [takenArray, untakenArray] = yield all([call(fetchAll, 'taken'), call(fetchAll, 'untaken')]);
      yield put(setPhotoShootMapData([takenArray, untakenArray]));
    } else if (filter === 'taken' || filter === 'untaken') {
      const only = yield call(fetchAll, filter);
      yield put(setPhotoShootMapData([filter === 'taken' ? only : [], filter === 'untaken' ? only : []]));
    }

    yield put(setPageTopLoader(false));
  } catch (err) {
    console.log(err);
    yield put(setPageTopLoader(false));
  }
}

// Data source: S3
export function* getPictreeDataPhotoShootMapNttSxiOptimized2(action) {
  try {
    yield put(setPageTopLoader(true));
    yield put(setPhotoShootMapDataNtt([]));

    const seasonSelectedNtt = yield select(selectedSeasonNtt);
    const seasonId = seasonSelectedNtt[0]["seasonId"];　// cmg7iw3va00017bow596s39cs

    const filter = action && action.payload && action.payload.filter;
    const needTaken = filter === "taken" || filter === "taken+untaken";
    const needUntaken = filter === "untaken" || filter === "taken+untaken";

    // 1) S3/CF 上の URL を組み立て
    const basePath = `${NTT_MAP_BASE_URL}/ntt/${seasonId}`;
    const cacheBuster = `t=${Date.now()}`;
    const pointsUrl = `${basePath}/points_latest.geojson.gz?${cacheBuster}`;
    const summaryUrl = `${basePath}/summary_latest.json?${cacheBuster}`;

    // 2) summary を取得（ヘッダー表示などに使いたければここで）
    //    まだ使わないならコメントアウトでもOK
    const summary = yield call(fetchJson, summaryUrl);

    // 3) points GeoJSON を取得
    const geojson = yield call(fetchJson, pointsUrl);

    if (!geojson || !Array.isArray(geojson.features)) {
      throw new Error("Invalid GeoJSON format (no features)");
    }

    const takenArray = [];
    const untakenArray = [];

    for (const feature of geojson.features) {
      if (!feature || feature.type !== "Feature") continue;
      const geom = feature.geometry || {};
      const props = feature.properties || {};

      const coords = geom.coordinates;
      if (!coords || coords.length < 2) continue;

      const lon = parseFloat(coords[0]);
      const lat = parseFloat(coords[1]);

      // Lambda 側で定義したカラム名に合わせる
      const powerAssetId = props.power_asset_id;
      const status = props.status; // 'APPROVED' or 'UNSHOT'

      // 既存の Store 形式に合わせてマッピング
      const row = {
        id: powerAssetId,
        asset_id: powerAssetId,
        latitude: lat,
        longitude: lon,
        // ↓ ここはプロジェクト側の表示に合わせて好きにマッピング
        prefectural_area: props.prefectural_area,
        exchange_office_name: props.exchange_office_name,
        asset_info: props.asset_info,
        photography_target: props.photography_target
      };

      if (status === "APPROVED") {
        if (needTaken) takenArray.push(row);
      } else {
        if (needUntaken) untakenArray.push(row);
      }
    }

    // 4) filter に応じて Redux store へ流し込む
    if (filter === "taken+untaken") {
      yield put(setPhotoShootMapDataNtt([takenArray, untakenArray]));
    } else if (filter === "taken") {
      yield put(setPhotoShootMapDataNtt([takenArray, []]));
    } else if (filter === "untaken") {
      yield put(setPhotoShootMapDataNtt([[], untakenArray]));
    } else {
      // filter 未指定なら全部
      yield put(setPhotoShootMapDataNtt([takenArray, untakenArray]));
    }

    yield put(setPageTopLoader(false));
  } catch (err) {
    console.log(err);
    yield put(setPageTopLoader(false));
  }
}

export function* getPictreeDataPhotoShootMapNttFt(action) {
  try {
    yield put(setPageTopLoader(true));
    yield put(setPhotoShootMapDataNtt([]));
    const seasonSelectedNtt = yield select(selectedSeasonNttFt);
    const seasonId = "cmkdxxnxn000141s4asb2gdfv"

    const filter = action && action.payload && action.payload.filter;
    const needTaken = filter === "taken" || filter === "taken+untaken";
    const needUntaken = filter === "untaken" || filter === "taken+untaken";

    // 1) S3/CF 上の URL を組み立て
    const basePath = `${NTT_MAP_BASE_URL}/ntt-ft/${seasonId}`;
    const cacheBuster = `t=${Date.now()}`;
    const pointsUrl = `${basePath}/points_latest.geojson.gz?${cacheBuster}`;
    const summaryUrl = `${basePath}/summary_latest.json?${cacheBuster}`;

    // 2) summary を取得（ヘッダー表示などに使いたければここで）
    //    まだ使わないならコメントアウトでもOK
    const summary = yield call(fetchJson, summaryUrl);

    // 3) points GeoJSON を取得
    const geojson = yield call(fetchJson, pointsUrl);

    if (!geojson || !Array.isArray(geojson.features)) {
      throw new Error("Invalid GeoJSON format (no features)");
    }

    const takenArray = [];
    const untakenArray = [];

    for (const feature of geojson.features) {
      if (!feature || feature.type !== "Feature") continue;
      const geom = feature.geometry || {};
      const props = feature.properties || {};

      const coords = geom.coordinates;
      if (!coords || coords.length < 2) continue;

      const lon = parseFloat(coords[0]);
      const lat = parseFloat(coords[1]);

      // Lambda 側で定義したカラム名に合わせる
      const powerAssetId = props.power_asset_id;
      const status = props.status; // 'APPROVED' or 'UNSHOT'

      // 既存の Store 形式に合わせてマッピング
      const row = {
        id: powerAssetId,
        asset_id: powerAssetId,
        latitude: lat,
        longitude: lon,
        // ↓ ここはプロジェクト側の表示に合わせて好きにマッピング
        prefectural_area: props.prefectural_area,
        exchange_office_name: props.exchange_office_name,
        asset_info: props.asset_info,
        photography_target: props.photography_target
      };

      if (status === "APPROVED") {
        if (needTaken) takenArray.push(row);
      } else {
        if (needUntaken) untakenArray.push(row);
      }
    }

    // 4) filter に応じて Redux store へ流し込む
    if (filter === "taken+untaken") {
      yield put(setPhotoShootMapDataNttFt([takenArray, untakenArray]));
    } else if (filter === "taken") {
      yield put(setPhotoShootMapDataNttFt([takenArray, []]));
    } else if (filter === "untaken") {
      yield put(setPhotoShootMapDataNttFt([[], untakenArray]));
    } else {
      // filter 未指定なら全部
      yield put(setPhotoShootMapDataNttFt([takenArray, untakenArray]));
    }

    yield put(setPageTopLoader(false));
  } catch (err) {
    console.log(err);
    yield put(setPageTopLoader(false));
  }
}

export function* getPictreeDataPhotoShootTrendByAssetNtt(action) {
  try {
    yield put(setPageTopLoader(true));
    const jwtToken = yield call(getJwtToken);
    const rangeTarget = yield select(dateRangeNtt);
    const seasonSelectedNtt = yield select(selectedSeasonNtt);
    const seasonId = seasonSelectedNtt[0]["seasonId"];
    const startUtc = moment
      .tz(`${rangeTarget[0]} 00:00:00`, "Asia/Tokyo")
      .utc()
      .format("YYYY-MM-DD HH:mm:ss");
    const endUtc = moment
      .tz(`${rangeTarget[1]} 00:00:00`, "Asia/Tokyo")
      .add(1, "day")
      .utc()
      .format("YYYY-MM-DD HH:mm:ss");

    let sqlQueryDenchuPhotoShootTrend = {
      query: `
        SELECT
          DATE(CONVERT_TZ(rre.occurred_datetime, 'UTC', 'Asia/Tokyo')) AS day,
          pa.type AS type,
          pa.sub_type AS sub_type,
          COUNT(DISTINCT rr.power_asset_id) AS cnt
        FROM review_request_event rre
        JOIN review_request rr ON rre.review_request_id = rr.id
        JOIN power_asset pa ON pa.id = rr.power_asset_id
        WHERE rre.game_space_id = '${seasonId}'
        AND rre.type = 'APPROVED'
        AND rre.occurred_datetime >= '${startUtc}'
        AND rre.occurred_datetime <  '${endUtc}'
        AND pa.sub_type IS NOT NULL
        GROUP BY day, type, sub_type
        ORDER BY day ASC, type ASC, sub_type ASC;`,
      database: "KpiDashboard",
      type: "list",
    };

    const [
      dataTrendBySubType,
    ] = yield all([
      call(
        getDataFromSxi,
        sqlQueryDenchuPhotoShootTrend,
        ENDPOINT.GET_DATA_SXI_DENCHU,
        jwtToken
      ),
    ]);
    const labelMap = chartConfig.chartLabelPicTreeAssetTypeNtt || assetConfig.assetSubTypeNtt;
    const getLabelByTypeAndSubType = (type, subType) => {
      if (type === "MAN_HOLE" && subType === "NORMAL") return "マンホール";
      if (type === "HAND_HOLE" && subType === "NORMAL") return "ハンドホール";
      return labelMap[subType] || subType || type;
    };

    const rawTrendData = (dataTrendBySubType || []).map((item) => ({
      day: moment(item.day).format("YYYY-MM-DD"),
      type: item.type,
      subType: item.sub_type,
      label: getLabelByTypeAndSubType(item.type, item.sub_type),
      cnt: Number(item.cnt) || 0,
    }));
    const xAxisDate = _.uniq(rawTrendData.map((d) => d.day)).sort();

    const typeRank = { POWER_POLE: 1, MAN_HOLE: 2, HAND_HOLE: 3 };
    const isLucky = (subType) => (subType || "").includes("LUCKY");
    const totals = new Map();
    const byLabelAndDay = new Map();
    const labelMeta = new Map();
    rawTrendData.forEach(({ label, day, cnt, type, subType }) => {
      totals.set(label, (totals.get(label) || 0) + cnt);
      byLabelAndDay.set(`${label}::${day}`, cnt);
      if (!labelMeta.has(label)) {
        labelMeta.set(label, { type: type || "UNKNOWN", subType: subType || "" });
      }
    });
    const activeLabels = Array.from(totals.keys())
      .filter((label) => (totals.get(label) || 0) > 0)
      .sort((a, b) => {
        const metaA = labelMeta.get(a) || { type: "UNKNOWN", subType: "" };
        const metaB = labelMeta.get(b) || { type: "UNKNOWN", subType: "" };
        const rankDiff = (typeRank[metaA.type] || 99) - (typeRank[metaB.type] || 99);
        if (rankDiff !== 0) return rankDiff;
        const luckyDiff = Number(isLucky(metaA.subType)) - Number(isLucky(metaB.subType));
        if (luckyDiff !== 0) return luckyDiff;
        return (totals.get(b) || 0) - (totals.get(a) || 0);
      });

    const recordArray = activeLabels.length > 0 ? [{ date: xAxisDate }] : [];
    activeLabels.forEach((label) => {
      const dataArray = xAxisDate.map((date) => byLabelAndDay.get(`${label}::${date}`) || 0);
      recordArray[0][label] = dataArray;
    });
    yield put(setPictreePhotoShootTrendByAssetNtt(recordArray));
    yield put(setPageTopLoader(false));
  } catch (err) {
    console.log(err);
  }
}

export function* getPictreeDataPhotoShootTrendByAssetNttFt(action) {
  try {
    yield put(setPageTopLoader(true));
    const jwtToken = yield call(getJwtToken);
    const rangeTarget = yield select(dateRangeNttFt);
    const seasonSelectedNtt = yield select(selectedSeasonNttFt);
    const seasonId = seasonSelectedNtt[0]["seasonId"];
    const startUtc = moment
      .tz(`${rangeTarget[0]} 00:00:00`, "Asia/Tokyo")
      .utc()
      .format("YYYY-MM-DD HH:mm:ss");
    const endUtc = moment
      .tz(`${rangeTarget[1]} 00:00:00`, "Asia/Tokyo")
      .add(1, "day")
      .utc()
      .format("YYYY-MM-DD HH:mm:ss");

    let sqlQueryDenchuPhotoShootTrend = {
      query: `
        SELECT
          DATE(CONVERT_TZ(rre.occurred_datetime, 'UTC', 'Asia/Tokyo')) AS day,
          pa.type AS type,
          pa.sub_type AS sub_type,
          COUNT(DISTINCT rr.power_asset_id) AS cnt
        FROM review_request_event rre
        JOIN review_request rr ON rre.review_request_id = rr.id
        JOIN power_asset pa ON pa.id = rr.power_asset_id
        WHERE rre.game_space_id = '${seasonId}'
        AND rre.type = 'APPROVED'
        AND rre.occurred_datetime >= '${startUtc}'
        AND rre.occurred_datetime <  '${endUtc}'
        AND pa.sub_type IS NOT NULL
        GROUP BY day, type, sub_type
        ORDER BY day ASC, type ASC, sub_type ASC;`,
      database: "KpiDashboard",
      type: "list",
    };

    const [
      dataTrendBySubType,
    ] = yield all([
      call(
        getDataFromSxi,
        sqlQueryDenchuPhotoShootTrend,
        ENDPOINT.GET_DATA_SXI_DENCHU,
        jwtToken
      ),
    ]);
    const labelMap = chartConfig.chartLabelPicTreeAssetTypeNtt || assetConfig.assetSubTypeNtt;
    const getLabelByTypeAndSubType = (type, subType) => {
      if (type === "MAN_HOLE" && subType === "NORMAL") return "マンホール";
      if (type === "HAND_HOLE" && subType === "NORMAL") return "ハンドホール";
      return labelMap[subType] || subType || type;
    };

    const rawTrendData = (dataTrendBySubType || []).map((item) => ({
      day: moment(item.day).format("YYYY-MM-DD"),
      type: item.type,
      subType: item.sub_type,
      label: getLabelByTypeAndSubType(item.type, item.sub_type),
      cnt: Number(item.cnt) || 0,
    }));
    const xAxisDate = _.uniq(rawTrendData.map((d) => d.day)).sort();

    const typeRank = { POWER_POLE: 1, MAN_HOLE: 2, HAND_HOLE: 3 };
    const isLucky = (subType) => (subType || "").includes("LUCKY");
    const totals = new Map();
    const byLabelAndDay = new Map();
    const labelMeta = new Map();
    rawTrendData.forEach(({ label, day, cnt, type, subType }) => {
      totals.set(label, (totals.get(label) || 0) + cnt);
      byLabelAndDay.set(`${label}::${day}`, cnt);
      if (!labelMeta.has(label)) {
        labelMeta.set(label, { type: type || "UNKNOWN", subType: subType || "" });
      }
    });
    const activeLabels = Array.from(totals.keys())
      .filter((label) => (totals.get(label) || 0) > 0)
      .sort((a, b) => {
        const metaA = labelMeta.get(a) || { type: "UNKNOWN", subType: "" };
        const metaB = labelMeta.get(b) || { type: "UNKNOWN", subType: "" };
        const rankDiff = (typeRank[metaA.type] || 99) - (typeRank[metaB.type] || 99);
        if (rankDiff !== 0) return rankDiff;
        const luckyDiff = Number(isLucky(metaA.subType)) - Number(isLucky(metaB.subType));
        if (luckyDiff !== 0) return luckyDiff;
        return (totals.get(b) || 0) - (totals.get(a) || 0);
      });

    const recordArray = activeLabels.length > 0 ? [{ date: xAxisDate }] : [];
    activeLabels.forEach((label) => {
      const dataArray = xAxisDate.map((date) => byLabelAndDay.get(`${label}::${date}`) || 0);
      recordArray[0][label] = dataArray;
    });

    yield put(setPictreePhotoShootTrendByAssetNttFt(recordArray));
    yield put(setPageTopLoader(false));
  } catch (err) {
    console.log(err);
  }
}

export function* getPictreeDataPhotoShootTrendHokuden(action) {
  try {
    yield put(setPageTopLoader(true));
    const jwtToken = yield call(getJwtToken);
    const rangeTarget = yield select(dateRangeHokuden);
    const propertyQuery = `AND (property = 'hepco')`;
    const selectedSeasonData = yield select(selectedSeasonHokuden);

    const seasonQuery = (() => {
      if (
        selectedSeasonData.length > 0 &&
        selectedSeasonData[0].seasonId !== undefined
      ) {
        const ids = selectedSeasonData.map((s) => `'${s.seasonId}'`).join(", ");
        // 長さが１なら単一、複数なら IN
        return selectedSeasonData.length === 1
          ? `AND (gameSpaceId = ${ids})` // ids は "'id1'"
          : `AND (gameSpaceId IN (${ids}))`; // ids は "'id1','id2',…"
      }
      return "";
    })();

    let sqlQueryDenchuPhotoShootTrend = {
      query: `
        SELECT DATE(convert_tz(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')) AS DAY, COUNT(denchuId)
        FROM DenchuPhotoShootDenchuEvtProd
        WHERE CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')
        BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59' ${propertyQuery} ${seasonQuery}
        GROUP BY DATE(convert_tz(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo'))
        ORDER BY logDate ASC;`,
      database: "KpiDashboard",
      type: "list",
    };

    if (action.payload === "hour") {
      sqlQueryDenchuPhotoShootTrend.query = `
        SELECT
          DATE_FORMAT(
              CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo'),
              '%Y-%m-%d %H:00'
          ) AS HOUR,
          COUNT(denchuId) AS denchu_count
        FROM
          DenchuPhotoShootDenchuEvtProd
        WHERE
          CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')
          BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59'
          ${propertyQuery} ${seasonQuery}
        GROUP BY
          HOUR
        ORDER BY
          HOUR ASC;
      `;
    }

    let sqlQueryPhotoShootUniqueTrend = {
      query: `
        SELECT
            DAY,
            COUNT(DISTINCT uid) AS DAU
        FROM (
            SELECT
                DATE(CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')) AS DAY,
                uid
            FROM DenchuPhotoShootDenchuEvtProd
            WHERE CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')
                BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59'
            ${propertyQuery} ${seasonQuery}

        ) AS combined_data
        GROUP BY DAY
        ORDER BY DAY ASC;
      `,
      database: "KpiDashboard",
      type: "list",
    };

    if (action.payload === "hour") {
      sqlQueryPhotoShootUniqueTrend.query = `
        SELECT
          HOUR,
          COUNT(DISTINCT uid) AS uid_count
        FROM (
          SELECT
              DATE_FORMAT(
                  CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo'),
                  '%Y-%m-%d %H:00'
              ) AS HOUR,
              uid
          FROM DenchuPhotoShootDenchuEvtProd
          WHERE
              CONVERT_TZ(FROM_UNIXTIME(logDate / 1000), 'UTC', 'Asia/Tokyo')
              BETWEEN '${rangeTarget[0]} 00:00:00' AND '${rangeTarget[1]} 23:59:59'
              ${propertyQuery} ${seasonQuery}
        ) AS combined_data
        GROUP BY HOUR
        ORDER BY HOUR ASC;
      `;
    }

    let sqlQueryNewUserDailyTrend = {
      query: `
        SELECT
          DATE(CONVERT_TZ(FROM_UNIXTIME(first_logDate/1000), 'UTC', 'Asia/Tokyo')) AS DAY,
          COUNT(*) AS new_unique_users
        FROM (
          SELECT
            uid,
            MIN(logDate) AS first_logDate,
            SUBSTRING_INDEX(
              GROUP_CONCAT(property ORDER BY logDate ASC),
              ',', 1
            ) AS first_property
          FROM DenchuPhotoShootDenchuEvtProd
          GROUP BY uid
        ) AS first_events
        WHERE
          first_property = 'hepco'
          AND first_logDate BETWEEN
            UNIX_TIMESTAMP(CONVERT_TZ('${rangeTarget[0]} 00:00:00', 'Asia/Tokyo','UTC')) * 1000
            AND UNIX_TIMESTAMP(CONVERT_TZ('${rangeTarget[1]} 23:59:59', 'Asia/Tokyo','UTC')) * 1000
        GROUP BY DAY
        ORDER BY DAY ASC;
      `,
      database: "KpiDashboard",
      type: "list",
    };
    if (action.payload === "hour") {
      sqlQueryNewUserDailyTrend.query = `
        SELECT
          DATE_FORMAT(
            CONVERT_TZ(FROM_UNIXTIME(first_logDate/1000), 'UTC', 'Asia/Tokyo'),
            '%Y-%m-%d %H:00'
          ) AS HOUR,
          COUNT(*) AS new_unique_users
        FROM (
          SELECT
            uid,
            MIN(logDate) AS first_logDate,
            SUBSTRING_INDEX(
              GROUP_CONCAT(property ORDER BY logDate ASC),
              ',', 1
            ) AS first_property
          FROM DenchuPhotoShootDenchuEvtProd
          GROUP BY uid
        ) AS first_events
        WHERE
          first_property = 'hepco'
          AND first_logDate BETWEEN
            UNIX_TIMESTAMP(CONVERT_TZ('${rangeTarget[0]} 00:00:00', 'Asia/Tokyo','UTC')) * 1000
            AND UNIX_TIMESTAMP(CONVERT_TZ('${rangeTarget[1]} 23:59:59', 'Asia/Tokyo','UTC')) * 1000
        GROUP BY HOUR
        ORDER BY HOUR ASC;
      `;
    }

    const [
      dataTempDenchuPhotoShootTrend,
      dataTempPhotoShootUniqueTrend,
      dataTempPhotoShootNewUserTrend,
    ] = yield all([
      //
      call(
        getDataFromRDS,
        sqlQueryDenchuPhotoShootTrend,
        ENDPOINT.GET_DATA_USERS,
        jwtToken
      ),
      call(
        getDataFromRDS,
        sqlQueryPhotoShootUniqueTrend,
        ENDPOINT.GET_DATA_USERS,
        jwtToken
      ),
      call(
        getDataFromRDS,
        sqlQueryNewUserDailyTrend,
        ENDPOINT.GET_DATA_USERS,
        jwtToken
      ),
    ]);

    const dataDenchuPhotoShootTrend = JSON.parse(
      dataTempDenchuPhotoShootTrend.body
    );;

    const dataPhotoShootUniqueTrend = JSON.parse(
      dataTempPhotoShootUniqueTrend.body
    );

    const dataPhotoShootNewUserTrend = JSON.parse(
      dataTempPhotoShootNewUserTrend.body
    );

    // Set xAxisDate
    let xAxisDate = [],
      dataDenchuArray = [],
      dataUniqueArray = [],
      dataNewUserArray = [],
      recordArray = [];
    const daysArray =
      action.payload === "day"
        ? H.FormatDateHelper.getDaysListBetweenDays(
            rangeTarget[0],
            rangeTarget[1]
          )
        : H.FormatDateHelper.getHoursListBetweenDays(
            rangeTarget[0],
            rangeTarget[1]
          );
    _.each(daysArray, function (data) {
      xAxisDate.push(data);
    });

    const allZero = (arr) => arr.every((v) => v === 0);

    xAxisDate.forEach((date) => {
      const data = _.find(
        dataDenchuPhotoShootTrend,
        (item) => _.get(item, "[0].stringValue") === date
      );
      if (data) {
        dataDenchuArray.push(_.get(data, "[1].longValue"));
      } else {
        dataDenchuArray.push(0);
      }

      // Unique data
      const uniqueData = _.find(
        dataPhotoShootUniqueTrend,
        (item) => _.get(item, "[0].stringValue") === date
      );
      if (uniqueData) {
        dataUniqueArray.push(_.get(uniqueData, "[1].longValue"));
      } else {
        dataUniqueArray.push(0);
      }

      // New User data
      const newUserData = _.find(
        dataPhotoShootNewUserTrend,
        (item) => _.get(item, "[0].stringValue") === date
      );
      if (newUserData) {
        dataNewUserArray.push(_.get(newUserData, "[1].longValue"));
      } else {
        dataNewUserArray.push(0);
      }
    });

    const countDenchu = allZero(dataDenchuArray) ? false : dataDenchuArray;

    const photoshootCountData = {
      date: xAxisDate,
      countDenchu,
      unique: dataUniqueArray,
      newUser: dataNewUserArray,
    };
    recordArray.push(photoshootCountData);
    console.log("LOG:: recordArray", recordArray);
    yield put(setPictreeDataPhotoShootTrendHokuden(recordArray));
    yield put(setPageTopLoader(false));
  } catch (err) {
    console.log(err);
  }
}

export function* getPictreeDataPhotoShootMapHokudenSxiOptimized(action) {
  try {
    yield put(setPageTopLoader(true));
    const jwtToken = yield call(getJwtToken);
    const LIMIT = 5000;
    let offset = 0;

    const seasonSelected = yield select(selectedSeasonHokuden);
    const seasonId = seasonSelected[0]["seasonId"];

    let recordArray = [];

    let sqlCountQuery;
    if (action.payload.filter === "taken") {
      sqlCountQuery = {
        query: `
          SELECT COUNT(*) AS count
          FROM power_asset AS pa
          INNER JOIN power_asset_detail_of_hepco AS padoh ON pa.id = padoh.power_asset_id
          INNER JOIN power_asset_detail pad ON pa.id = pad.power_asset_id
          INNER JOIN power_asset_state pas ON pa.id = pas.power_asset_id
          INNER JOIN review_request rr
              ON pa.id = rr.power_asset_id
              AND rr.game_space_id = '${seasonId}'
          WHERE pas.game_space_id = '${seasonId}'
          AND rr.status = 'APPROVED'
          AND pad.type = 'HEPCO'
        `,
        database: "KpiDashboard",
        type: "list",
      };
    } else {
      sqlCountQuery = {
        query: `
          SELECT COUNT(*) AS count
          FROM power_asset AS pa
          INNER JOIN power_asset_detail_of_hepco AS padoh ON pa.id = padoh.power_asset_id
          INNER JOIN power_asset_detail pad ON pa.id = pad.power_asset_id
          INNER JOIN power_asset_state pas ON pa.id = pas.power_asset_id
          LEFT JOIN review_request rr
              ON pa.id = rr.power_asset_id
              AND rr.game_space_id = '${seasonId}'
              AND rr.status = 'APPROVED'
          WHERE pas.game_space_id = '${seasonId}'
          AND rr.power_asset_id IS NULL
          AND pad.type = 'HEPCO'
        `,
        database: "KpiDashboard",
        type: "list",
      };
    }

    // ✅ データ総数を取得
    const [dataCount] = yield all([
      call(
        getDataFromSxi,
        sqlCountQuery,
        ENDPOINT.GET_DATA_SXI_DENCHU,
        jwtToken
      ),
    ]);
    const totalCount = dataCount[0]["count"];

    // ✅ 並列リクエスト用の配列作成
    let requests = [];
    while (offset < totalCount) {
      const sqlQuery = {
        query: `
          SELECT *
          FROM power_asset AS pa
          INNER JOIN power_asset_detail_of_hepco AS padoh ON pa.id = padoh.power_asset_id
          INNER JOIN power_asset_state pas ON pa.id = pas.power_asset_id
          INNER JOIN power_asset_detail pad ON pa.id = pad.power_asset_id
          ${
            action.payload.filter === "taken"
              ? `INNER JOIN review_request rr
                ON pa.id = rr.power_asset_id
                AND rr.game_space_id = '${seasonSelected[0]["seasonId"]}'
                AND rr.status = 'APPROVED'
                AND pad.type = 'HEPCO'
                `
              : `LEFT JOIN review_request rr
                ON pa.id = rr.power_asset_id
                AND rr.game_space_id = '${seasonSelected[0]["seasonId"]}'
                AND rr.status = 'APPROVED'
                AND pad.type = 'HEPCO'
               WHERE rr.power_asset_id IS NULL AND pas.game_space_id = '${seasonSelected[0]["seasonId"]}'
               `
          }
          LIMIT ${LIMIT} OFFSET ${offset};
        `,
        database: "KpiDashboard",
        type: "list",
      };
      requests.push(
        call(getDataFromSxi, sqlQuery, ENDPOINT.GET_DATA_SXI_DENCHU, jwtToken)
      );
      offset += LIMIT;
    }

    // ✅ 並列実行（🔥全てのリクエストを一気に発火！）
    const results = yield all(requests);

    // ✅ データを統合
    results.forEach((dataBatch) => {
      dataBatch.forEach((data) => {
        recordArray.push({
          id: data["power_asset_id"],
          asset_id: data["power_asset_id"],
          latitude: parseFloat(data["latitude"]),
          longitude: parseFloat(data["longitude"]),
          asset_number: data["power_pole_number"],
          branch_code: data["branch_code"],
          city_name: data["representative_municipality_name"],
        });
      });
    });
    const finalData = recordArray.length > 0 ? recordArray : {taken: [], untaken: []};
    yield put(setPhotoShootMapDataHokuden({taken: finalData, untaken: []}));
    yield put(setPageTopLoader(false));
  } catch (err) {
    console.log(err);
  }
}

export default function* watchPageSettings() {
  yield takeEvery(PICTREE.GET_PHOTOSHOOT_DETAILS,getPictreeDataPhotoShootDetails);
  yield takeEvery(PICTREE.GET_PHOTOSHOOT_TREND, getPictreeDataPhotoShootTrend);
  yield takeEvery(PICTREE.GET_PHOTOSHOOT_TREND_NTT, getPictreeDataPhotoShootTrendNtt);
  yield takeEvery(PICTREE.GET_PHOTOSHOOT_TREND_NTT_FT, getPictreeDataPhotoShootTrendNttFt);
  yield takeEvery(PICTREE.GET_PHOTOSHOOT_DENCHU_KAISU_TREND, getPictreeDataPhootoShootKaisuTrend);
  yield takeEvery(PICTREE.GET_PHOTOSHOOT_MAP_DATA,getPictreeDataPhotoShootMapTepcoSxiOptimized2);
  yield takeEvery(PICTREE.GET_PHOTOSHOOT_MAP_DATA_NTT, getPictreeDataPhotoShootMapNttSxiOptimized2);
  yield takeEvery(PICTREE.GET_PHOTOSHOOT_MAP_DATA_NTT_FT, getPictreeDataPhotoShootMapNttFt);
  yield takeEvery(PICTREE.GET_PHOTOSHOOT_TREND_BY_ASSET_NTT, getPictreeDataPhotoShootTrendByAssetNtt);
  yield takeEvery(PICTREE.GET_PHOTOSHOOT_TREND_BY_ASSET_NTT_FT, getPictreeDataPhotoShootTrendByAssetNttFt);
  yield takeEvery(PICTREE.GET_PHOTOSHOOT_TREND_HOKUDEN, getPictreeDataPhotoShootTrendHokuden);
  yield takeEvery(PICTREE.GET_PHOTOSHOOT_MAP_DATA_HOKUDEN, getPictreeDataPhotoShootMapHokudenSxiOptimized);
}
